import { AfterViewInit, Component, ElementRef, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef, HostListener, Input, OnInit, OnChanges, Output, ViewChild, ContentChild, TemplateRef, SimpleChanges } from '@angular/core';
import { Actions, TableColumn } from './TableColumn';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { SelectionModel } from '@angular/cdk/collections';
import { MatTableExporterDirective } from 'mat-table-exporter';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { ExportService } from '@app/exportservice/export.service';
import { GetService } from './get.service';
import { UpdateStatusService } from '@app/shared/table/updateStatus.service';
import { DownloadService } from '../services/download.service';
import { FormControl, FormGroup } from '@angular/forms';
import moment from 'moment';
import { TreeviewConfig, TreeviewItem, TreeviewI18n } from '@samotics/ngx-treeview';
import { ATTRIBUTES, NO_PREVIEW, TAGS } from '../constants/application-constants';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NonedittextboxComponent } from '../components/nonedittextbox/nonedittextbox.component';
import { DomSanitizer } from '@angular/platform-browser';
import { TagsMasterService } from '@app/content/tags-master/tags-master.service';
import { LeadService } from '@app/sales/leads/leads.service';
import { UtilService } from '../services/util.service';
import { buildTableColumnPreferencesKey } from './table-column-preferences';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
declare var $: any;

export interface dateRangeElement {
  isSingle: boolean;
  startDataKey: string;
  endDataKey: string;
}

export enum constants {
  LIST = 'list',
  DATE = 'date',
  BETWEEN = 'between',
  ALL = 'all',
  TEXT = 'text',
  NUMBER = 'number',
  CONTAINS = 'contains',
  IS = 'is',
  STATUS = 'status',
  STATIC = 'static',
  AMOUNT = 'amount',
  IMPRESSION_COUNT = 'impression_count'
}

import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatChipsModule } from '@angular/material/chips';
import { MatTableExporterModule } from 'mat-table-exporter';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TreeviewModule } from '@samotics/ngx-treeview';
import { HighlightSearchPipe } from './highlight-search-pipe/highlight-search.pipe';
import { StripHtmlPipe } from '../Pipes/striphtml.pipe';
import { DataPropertyGetterPipe } from './data-property-getter-pipe/data-property-getter-pipe.pipe';
import { BreadcrumbComponent } from '../components/breadcrumb/breadcrumb.component';
import { AccessControlDirective } from '../directives/access-control.directive';
import { FilterComponent } from '../components/filter/filter.component';

@Component({
    imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, MatTableModule, MatPaginatorModule, MatSortModule, MatCheckboxModule, MatIconModule, MatMenuModule, MatButtonModule, MatTooltipModule, MatDialogModule, MatSelectModule, MatInputModule, MatDatepickerModule, MatNativeDateModule, MatChipsModule, MatTableExporterModule, DragDropModule, TreeviewModule, HighlightSearchPipe, StripHtmlPipe, DataPropertyGetterPipe, BreadcrumbComponent, MatSlideToggleModule, AccessControlDirective, FilterComponent],
    selector: 'custom-table',
    templateUrl: './table.component.html',
    styleUrls: ['./table.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableComponent implements OnInit, OnChanges, AfterViewInit {
  public tableDataSource = new MatTableDataSource([]);
  public selection = new SelectionModel(true, []);
  public displayedColumns: string[];
  ignoreColumnNames: string[] = [
    "Id", "Sno", "Group Candidates", "Qpv Selected", "HideModify", "Rules", "Initial Text",
    "Blank Indices Start End Data", "Actual", "Actual Statement Text", "Count Of Blanks",
    "Blank Text Ans Key Data", "Question Options", "Kpi Records", "created_user_username",
    "Show Link", "Processed Question Text", "Questiongroupinglogic", "EvaluavatedAndUnpublished",
    "Preview", "Unpublished", "Evaluation", "Organization Name", "Total Count",
    "Formatted Visibility Tags", "Is Current", "Current Label", "Is Current Version",
    "Resend Tooltip", "Reset Tooltip", "Can Resend Verification", "Token Expiry", "Reporting To",
    "Pass Analysis", "Pass Details"
  ];
  @Input() extraIgnoreFilterKeys: string[] = [];
  @Input() extraIgnoreColumnNames: string[] = [];
  allColumnNames: string[] = [];
  visibleColumns: string[] = [];
  tempVisibleColumns: string[] = [];
  private baseTableColumns: TableColumn[] = [];
  private readonly fixedVisibleColumns = new Set(['S.No.', 'Status', 'Actions']);
  // Treeview properties
  treeDropdownColumns: TreeviewItem[] = [];
  treeConfig = TreeviewConfig.create({
    hasAllCheckBox: true,
    hasFilter: true,
    hasCollapseExpand: false,
    decoupleChildFromParent: false,
    maxHeight: 500
  });

  // Open tree dropdown flag
  treeDropdownOpen = false;
  private originalTableData: Array<any>;
  private _deselectAllSelected: boolean;
  public searchedString: string = '';
  NO_PREVIEW = NO_PREVIEW;
  readonly constants: typeof constants = constants;
  // Label dropdown properties
  OrganizationId: any = localStorage.getItem('OrganizationId');
  showTableLabelDropdownFlag: boolean = false;
  tableRemainningLabels: any[] = [];
  tableDropdownPosition: { top: number; left: number } = { top: 0, left: 0 };
  range = new FormGroup({
    start: new FormControl<Date | null>(new Date()),
    end: new FormControl<Date | null>(null),
  });
  config = TreeviewConfig.create({
    hasAllCheckBox: true,
    hasFilter: true,
    hasCollapseExpand: false,
    decoupleChildFromParent: false,
    maxHeight: 500,
  });
  defaultTreeViewItem = {
    text: 'Select options',
    value: '',
    checked: false,
    disabled: true,
  };
  buttonElement: any;
  fullContent: string;
  fullContentTitle: string;
  @Input() isLoading: boolean = false;

  @ViewChild('treeviewContainer') treeViewContainer: ElementRef;
  @ViewChild('viewAllTagsModal') viewAllTagsModal: ElementRef;
  @ViewChild(MatPaginator, { static: false }) matPaginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) matSort: MatSort;
  @ViewChild(MatTableExporterDirective, { static: false })
  exporter: MatTableExporterDirective;
  @ContentChild('labelFilterButtonTemplate') labelFilterButtonTemplate: TemplateRef<any>;
  @Input() isPageable = true;
  @Input() isdatePicker = false;
  @Input() onlyDefaultColumns = false;
  @Input() showBreadcrumb = true;
  @Input() isFilterPresent = false;
  @Input() dateDateKey: string;
  @Input() isSortable = true;
  @Input() isFilterable = true;
  @Input() tableColumns: TableColumn[] = [];
  @Input() tableActions: Array<Actions> = [];
  @Input() paginationSizes: number[] = [10, 20, 50, 100];
  @Input() defaultPageSize = this.paginationSizes[0];
  @Input() rowActions: Array<Actions> = [];
  @Input() tableTitle: string;
  @Input() filterAttributes: Array<any> = [];
  @Input() radioButtonCallBack: Function;
  private _selectedItems: any[] = [];
  baseCorrectSequence: any;
  @Input()
  set selectedItems(value: any[]) {
    this._selectedItems = Array.isArray(value) ? [...value] : [];
    if (this.moduleType === 'questions' || this.pageType === 'question banks') {
        this.restoreSelectionForCurrentPage();
      }
  }
  get selectedItems(): any[] {
    return this._selectedItems;
  }
  @Input() enablePreSelection: boolean = false;
  @Output() selectedItemsChange = new EventEmitter<any>();
  @Input() hiddenColumns: Array<number>;
  @Input() moduleType: string;
  @Input() pageType: string;
  @Input() columnPreferencePageType: string;

  @Input() permissionModuleType: string;
  @Input() permissionPageType: string;

  get accessControlModuleType(): string {
    return this.permissionModuleType || this.moduleType;
  }

  get accessControlPageType(): string {
    return this.permissionPageType || this.pageType;
  }
  @Input() truncateRichText: boolean = false;
  @Output() sort: EventEmitter<Sort> = new EventEmitter();
  @Output() allTextSearch: EventEmitter<string> = new EventEmitter<string>();
  @Output() rowAction: EventEmitter<any> = new EventEmitter<any>();
  @Output() toogleEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Input() handleToggleInParent: boolean = false;
  @Input() selectAllMode: 'page' | 'all' = 'page';
  @Output() tableActionEmitter: EventEmitter<any> = new EventEmitter<any>();

  get selectedCount(): number {
    return Array.isArray(this.selectedItems) ? this.selectedItems.length : 0;
  }
  @Output() tableDateRangeEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Input() dateRangeDetails: dateRangeElement;
  @Output() tableActionTag: EventEmitter<any> = new EventEmitter<any>();
  @Input() isTableActionTagPresent = false;
  @Output() countButtonEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() richTextClick: EventEmitter<any> = new EventEmitter<any>();
  @Input() totalCount: number = 0;
  @Input() serverSidePagination: boolean = false;
  @Output() page = new EventEmitter<any>();
  selectedCandidate: any;
  selectedTatAnalysis: any;
  currentFilters: any = {};
  @Input() set tableData(data: any[]) {
    // this.isLoading = true;
    this.cdr.markForCheck();
    if (!data) return;

    // console.log('=== RAW TABLE INPUT DATA ===');
    // if (data.length > 0) {
    //   console.log('First item raw:', data[0]);
    //   console.log('rootLabelColors in first item:', data[0].rootLabelColors);
    //   console.log('rootLabelCount in first item:', data[0].rootLabelCount);
    //   console.log('Created DateTime:', data[0].created_datetime);
    //   console.log('Modified DateTime:', data[0].modified_datetime);
    // }
    // console.log('========================');

    // console.log('input table data', data);
    // console.log('All rootLabelColors:', data.map(d => ({ id: d.question_id, colors: d.rootLabelColors })));

    // // Sort based on datetime fields (recent first)
if (
  data.length > 0 &&
  this.pageType !== 'roles' &&
  this.pageType !== 'users' &&
  this.pageType !== 'user category' &&
  this.pageType !== 'bills' &&
  this.pageType !== 'candidates'
) {      data = [...data].sort((a, b) => {
        const dateA = a.modified_datetime ? new Date(a.modified_datetime).getTime() : new Date(a.created_datetime).getTime();
        const dateB = b.modified_datetime ? new Date(b.modified_datetime).getTime() : new Date(b.created_datetime).getTime();

        // If both are invalid dates → don't change order
        if (isNaN(dateA) && isNaN(dateB)) return 0;

        // Invalid dates (null) → push to bottom
        if (isNaN(dateA)) return 1;
        if (isNaN(dateB)) return -1;

        return dateB - dateA; // recent first
      });

      // Reset serial numbers
       if (this.moduleType === 'questions' || this.pageType === 'question banks') {

          // Question page → global serial number
          const startIndex =
            (this.matPaginator?.pageIndex || 0) *
            (this.matPaginator?.pageSize || this.defaultPageSize);

          data = data.map((row, index) => ({
            ...row,
            sno: startIndex + index + 1
          }));

        } else if (this.serverSidePagination && this.pageType === 'assessments') {
          const startIndex = (this.matPaginator?.pageIndex || 0) *
            (this.matPaginator?.pageSize || this.defaultPageSize);
          data = data.map((row, index) => ({
            ...row,
            sno: startIndex + index + 1
          }));
        } else {
        const startIndex = 0;
    // (this.matPaginator?.pageSize || this.defaultPageSize);
        data = data.map((row, index) => ({
          ...row,
        sno: startIndex + index + 1
        }));
        }
      }
      this.cdr.markForCheck();

    console.log('data aftere sorting', data);

    // setTimeout(() => {

      // Initialize with tableColumns names
      this.allColumnNames = this.tableColumns.map(col => col.name);

      console.log(this.moduleType, this.pageType, this.onlyDefaultColumns, 'this.filterAttributes', this.filterAttributes)

      this.filterAttributes = this.filterAttributes.filter((item: any) => item.type != 'all');
      const existingFilterKeys = this.filterAttributes.map(f => f.dataKeyName?.toString().trim().toLowerCase());
      const existingFilterNames = this.filterAttributes.map(f => f.name?.toString().trim().toLowerCase().replace(/[\s_]/g, '').replace(/s$/, ''));

      // If data is available
if (!this.onlyDefaultColumns && data.length > 0) {
  Object.keys(data[0]).forEach(key => {
        if (key === 'formattedProducts' || key === 'product_names' || key === 'product_names_count' || key === 'variable_fee' || key === 'opportunity') {
      return;
    }
    if (key == 'is_active' || key == 'is_deleted' || key == 'is_archived' || key == 'isActionDisabled' || key == 'isPublished' || key == 'hideModify' || key == 'is_published' || key == 'is_action_disabled') return;
    
    if (key.includes('tat') || key.includes('TAT')) return;
    if (key === 'pass_analysis' || key === 'pass_details') return;
    
    // Map key to column name
    const col = this.tableColumns.find(c => c.dataKey === key);
    let colName = col
      ? col.name
      : key
        .replace(/_/g, ' ')
        .replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1));

    const normalizedColName = colName.toString().trim().toLowerCase().replace(/[\s_]/g, '').replace(/s$/, '');
    const normalizedKey = key.toString().trim().toLowerCase();

    if (
      !this.ignoreColumnNames.includes(colName) &&
      !this.isExtraIgnoredFilterKey(key) &&
      !this.isExtraIgnoredFilterKey(colName) &&
      !this.isIgnoredColumn(key) &&
      !this.isIgnoredColumn(colName) &&
      !(colName.toLowerCase().includes('id') && !colName.toLowerCase().includes('candidate')) &&
      !['sno', 'status'].includes(key.toLowerCase()) &&
      !existingFilterKeys.includes(normalizedKey) &&
      !existingFilterNames.includes(normalizedColName)
    ) {
      existingFilterKeys.push(normalizedKey);
      existingFilterNames.push(normalizedColName);
      this.filterAttributes.push({
        dataKeyName: key,
        name: colName,
        type: colName.toLowerCase().includes('datetime') ? 'date' : 'text',
        data: []
      });
    }

    // Skip if column is excluded for this page
    if (this.isIgnoredColumn(key) || this.isIgnoredColumn(colName)) return;

    // Skip if column already exists
    if (this.allColumnNames.includes(colName)) return;

    const statusIndex = this.allColumnNames.indexOf('Status');
    const actionsIndex = this.allColumnNames.indexOf('Actions');

    // Determine where to insert
    if (statusIndex !== -1) {
      this.allColumnNames.splice(statusIndex, 0, colName);
    } else if (actionsIndex !== -1) {
      this.allColumnNames.splice(actionsIndex, 0, colName);
    } else {
      this.allColumnNames.push(colName);
    }
  });
}

      // Ensure S.No. is first
      if (this.allColumnNames[0] !== 'S.No.') {
        const snoIndex = this.allColumnNames.indexOf('S.No.');
        if (snoIndex !== -1) this.allColumnNames.splice(snoIndex, 1);
        this.allColumnNames.unshift('S.No.');
      }
      this.initializeColumnPreferences();

      // Normalize all datetime fields for display and search
      data = data.map((item: any) => {
        const updated = { ...item };

        // Convert any key ending with _datetime to 'DD-MMM-YYYY'
        Object.keys(updated).forEach(key => {
          if (key.toLowerCase().endsWith('_datetime') && updated[key]) {
            updated[key] = moment(updated[key]).format('DD-MMM-YYYY');
          }
        });

        return updated;
      });

      this.setTableDataSource(data);

    // });
  }
  @Input() hideTableTitle: boolean = false;
  @Input()
  set deselectAllSelected(value: boolean) {
    this._deselectAllSelected = value;
    this.handleDeselectAllSelectedChange(value);
  }

  get deselectAllSelected(): boolean {
    return this._deselectAllSelected;
  }

  handleDeselectAllSelectedChange(value: boolean) {
    if (value) {
      this.selection.clear();
      this.selectedItems = [];
    }
  }

  // @Output() selectedItemsChange = new EventEmitter<any[]>();
  allTextFilterValue = '';
  allTags: any;
  allAttributes: any;
  selectedFilters = {
    filters: {},
  };
  type: any;
  allInstructions: string;
  labelHierarchy: any[] = [];

  defaultFilterAttributes = [
    {
      "dataKeyName": "addedOn",
      "name": "Added On",
      "type": "date",
      "data": []
    },
    {
      "dataKeyName": "status",
      "name": "Status",
      "type": "status",
      "data": [
        "Active",
        "Inactive",
        "Deleted",
        "Archived"
      ]
    },
    {
      "dataKeyName": "full_name",
      "name": "Name",
      "type": "text",
      "data": []
    },
    {
      "dataKeyName": "username",
      "name": "Username",
      "type": "text",
      "data": []
    },
    {
      "dataKeyName": "custom_attrs",
      "name": "Attributes",
      "type": "text",
      "data": []
    },
    {
      "dataKeyName": "all",
      "name": "All Text",
      "type": "all",
      "data": []
    }
  ];

  private dialogRef: MatDialogRef<NonedittextboxComponent> | null = null;

  constructor(
    private exportService: ExportService,
    private updateStatusService: UpdateStatusService,
    private downloadService: DownloadService,
    private dialog: MatDialog,
    private sanitizer: DomSanitizer,
    private treeviewI18n: TreeviewI18n,
    private getService: GetService,
    private cdr: ChangeDetectorRef,
    private tagsMasterService: TagsMasterService,
    private contentLabelService: LeadService,
    private util: UtilService
  ) {
    this.treeviewI18n.getFilterPlaceholder = () => 'Search';
  }
  @Input() filteredData: any = {
    filters: {},
  };

  // Tag cache for lookups
  private tagsCache: Map<number, any> = new Map();
  private tagsLoaded = false;

  ngOnInit(): void {
    // Load tags only for questiontables
    if (this.pageType === 'question banks') {
      this.loadAllTags();
    }
    
    if (!Array.isArray(this.selectedItems)) {
      this.selectedItems = [];
    }
    const currentData = this.tableDataSource.data;

    this.selection.clear();

    const selectedIdSet = new Set(this.selectedItems.map((item: any) => item.id));
    const selectedRows = currentData.filter(row => selectedIdSet.has(row.id));

    this.selection.select(...selectedRows);
    this.selectedFilters = this.filteredData;

    const columnNames = this.tableColumns.map((tableColumn: TableColumn) => tableColumn.name);
    this.displayedColumns = columnNames;
    this.initializeColumnPreferences();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['tableColumns']?.currentValue) {
      this.captureBaseColumns(changes['tableColumns'].currentValue);
    }
    if (changes['tableColumns'] || changes['moduleType'] || changes['pageType'] || changes['columnPreferencePageType'] || changes['onlyDefaultColumns']) {
      this.initializeColumnPreferences();
    }
    if (changes['totalCount'] && this.serverSidePagination && this.matPaginator) {
      this.matPaginator.length = this.totalCount;
      this.cdr.markForCheck();
    }
  }

  ngAfterViewInit(): void {
    if (this.moduleType !== 'questions' && this.pageType !== 'question banks' && !this.serverSidePagination) {
      this.tableDataSource.paginator = this.matPaginator;
    }
    if (this.serverSidePagination && this.matPaginator) {
      this.matPaginator.length = this.totalCount;
    }
    // this.tableDataSource.paginator = this.matPaginator;
    this.tableDataSource._updateChangeSubscription();
  }

  @HostListener('document:click', ['$event'])
  onTableDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (this.showTableLabelDropdownFlag) {
      const dropdownElement = document.getElementById('tableLabeLDropdownPopup');
      const isClickInside = (dropdownElement && dropdownElement.contains(target)) || 
                            target.closest('.label-dot-more') !== null;
      
      if (!isClickInside) {
        this.closeTableLabelDropdown();
      }
    }
  }

  @HostListener('document:click', ['$event'])
  onClick(event: MouseEvent) {
    if (!this.treeDropdownOpen || !this.treeViewContainer) return;

    const targetElement = event.target as HTMLElement;

    // Check if the click is inside the dropdown
    const clickedInsideDropdown = this.treeViewContainer.nativeElement.contains(targetElement);

    // Check if the click is on the settings button (or its child)
    const clickedOnSettingsBtn = targetElement.closest('.settings-btn');

    if (!clickedInsideDropdown && !clickedOnSettingsBtn) {
      this.cancelColumnSelection();
    }
  }


  keyLength = (obj) => Object.keys(obj).length;

  isAllSelected() {
    if (this.serverSidePagination) {
      const currentPageIds = new Set(this.tableDataSource.data.map((row: any) => row.id));
      const selectedOnPage = this._selectedItems.filter((item: any) => currentPageIds.has(item.id));
      return this.tableDataSource.data.length > 0 && selectedOnPage.length === this.tableDataSource.data.length;
    }
    const numSelected = this.selection.selected.length;
    const numRows = this.tableDataSource.data.length;
    return numSelected === numRows;
  }

  get isColumnsChanged(): boolean {
    if (!this.visibleColumns || !this.tempVisibleColumns) return false;
    if (this.visibleColumns.length !== this.tempVisibleColumns.length) return true;

    const sortedVisible = [...this.visibleColumns].sort();
    const sortedTemp = [...this.tempVisibleColumns].sort();
    return sortedVisible.some((col, i) => col !== sortedTemp[i]);
  }

  // Toggle tree dropdown open/close
  toggleTreeDropdown() {
    // Make a temporary copy of current visibleColumns for cancel functionality
    this.tempVisibleColumns = [...this.visibleColumns];

    // Open/close dropdown
    this.treeDropdownOpen = !this.treeDropdownOpen;
    if (this.treeDropdownOpen) {
      // Reset Treeview selection when opening
      this.syncTreeviewSelection(this.visibleColumns);
    }
  }

  // Reset ngx-treeview selection
  private syncTreeviewSelection(columns: string[]) {
    if (!this.treeDropdownColumns) return;
    const selectedColumns = new Set(columns || []);

    // Iterate over all tree items and set checked status
    this.treeDropdownColumns.forEach(item => {
      item.checked = selectedColumns.has(item.text); // match with visibleColumns
      if (item.children && item.children.length) {
        this.resetChildSelection(item.children, selectedColumns);
      }
    });
  }

  resetChildSelection(children: any[], selectedColumns: Set<string>) {
    children.forEach(child => {
      child.checked = selectedColumns.has(child.text);
      if (child.children && child.children.length) {
        this.resetChildSelection(child.children, selectedColumns);
      }
    });
  }

  // Handle selection change from tree dropdown
onTreeviewCheckedChange(selectedValues: any[]) {

  if (this.pageType === 'roles') {
    this.tempVisibleColumns = selectedValues.map((v: any) => {
      if (typeof v === 'string') return v;
      if (v?.item?.value !== undefined) return v.item.value;
      if (v?.value !== undefined) return v.value;
      return v;
    });
  } else {
    this.tempVisibleColumns = selectedValues; // Store in temp until confirm
  }
}

  resetToDefaultColumns() {
    const baselineColumns = this.getBaseTableColumns();
    const defaultColumns = this.normalizeVisibleColumns(this.getDefaultVisibleColumns(), baselineColumns);

    this.visibleColumns = [...defaultColumns];
    this.tempVisibleColumns = [...defaultColumns];
    this.savePersistedVisibleColumns(this.visibleColumns);
    this.updateDisplayedColumns();
    this.syncTreeviewSelection(this.visibleColumns);
    this.treeDropdownOpen = false;
  }

  handlePageEvent(event: any) {
    if (this.moduleType === 'questions' || this.pageType === 'question banks' || this.serverSidePagination) {
      this.page.emit(event);
    }
  }
  trackByFn(index: number, item: any): any {
    return item.question_id || item.id || index;
  }
  trackByQuestionId(index: number, item: any): number {
    return item.question_id || item.id || index;
  }

  // Confirm selection
  confirmColumnSelection() {
    const selectedColumns = Array.isArray(this.tempVisibleColumns) ? [...this.tempVisibleColumns] : [];
    this.ensureVisibleColumnsExistInTableColumns(selectedColumns);
    this.visibleColumns = this.normalizeVisibleColumns(selectedColumns);
    this.savePersistedVisibleColumns(this.visibleColumns);
    this.updateDisplayedColumns();
    this.treeDropdownOpen = false; // Close dropdown
  }

  // Cancel selection
  cancelColumnSelection() {
    this.tempVisibleColumns = [...this.visibleColumns];
    this.treeDropdownOpen = false; // Close dropdown
  }

  private initializeColumnPreferences(): void {
    if (!Array.isArray(this.tableColumns) || this.tableColumns.length === 0) {
      return;
    }

    this.captureBaseColumns();
    const persistedColumns = this.loadPersistedVisibleColumns();
    const fallbackColumns = this.visibleColumns?.length
      ? this.visibleColumns
      : this.getInitialVisibleColumns();
    const columnsToUse = persistedColumns !== null ? persistedColumns : fallbackColumns;

    this.ensureVisibleColumnsExistInTableColumns(columnsToUse);
    this.visibleColumns = this.normalizeVisibleColumns(columnsToUse, this.tableColumns);
    this.tempVisibleColumns = [...this.visibleColumns];
    this.rebuildTreeDropdownColumns();
    this.updateDisplayedColumns();
  }

  private getInitialVisibleColumns(): string[] {
    return this.getDefaultColumnNames();
  }

  private getDefaultVisibleColumns(): string[] {
    return this.getDefaultColumnNames();
  }

  private getDefaultColumnNames(): string[] {
    return this.getBaseTableColumns()
      .filter(col => col.isDefault !== false && !this.isIgnoredColumn(col.name))
      .map(col => col.name);
  }

  private isIgnoredColumn(columnName: string | null | undefined): boolean {
    if (!columnName) {
      return false;
    }

    const normalizedName = columnName.toString().trim().toLowerCase().replace(/[\s_]/g, '');
    const matches = (value: string) => value?.toString().trim().toLowerCase().replace(/[\s_]/g, '') === normalizedName;

    return (
      this.ignoreColumnNames.some(matches) ||
      this.extraIgnoreColumnNames.some(matches)
    );
  }

  private isExtraIgnoredFilterKey(columnName: string | null | undefined): boolean {
    if (!columnName) {
      return false;
    }

    const normalizedName = columnName.toString().trim().toLowerCase().replace(/[\s_]/g, '');
    return this.extraIgnoreFilterKeys.some(
      value => value?.toString().trim().toLowerCase().replace(/[\s_]/g, '') === normalizedName
    );
  }

  private loadPersistedVisibleColumns(): string[] | null {
    const currentKey = this.getColumnPreferencesKey();
    const legacyKey = this.getLegacyColumnPreferencesKey();
    const keysToTry = [currentKey, legacyKey].filter((key): key is string => !!key);

    for (const key of keysToTry) {
      const rawValue = localStorage.getItem(key);
      if (!rawValue) {
        continue;
      }

      try {
        const parsed = JSON.parse(rawValue);
        const columns = Array.isArray(parsed)
          ? parsed.filter((item): item is string => typeof item === 'string')
          : null;

        if (columns && currentKey && key !== currentKey) {
          localStorage.setItem(currentKey, JSON.stringify(columns));
        }

        if (columns) {
          return columns.map(col => {
            if (col === 'Attended Count') return 'Candidates Appeared';
            if (col === 'Total Candidates') return 'Total Candidates Enrolled';
             if (col === 'Assessment Delivery Mode') return 'Delivery Mode';
            if (col === 'Mode of Assessment') return 'Evaluation Mode';
            if (col === 'Type of Assessment') return 'Evaluation Mode';
            return col;
          });
        }
      } catch {
        continue;
      }
    }

    return null;
  }

  private savePersistedVisibleColumns(columns: string[]): void {
    const key = this.getColumnPreferencesKey();
    if (!key) {
      return;
    }

    localStorage.setItem(key, JSON.stringify(this.normalizeVisibleColumns(columns)));
  }

  private getColumnPreferencesKey(): string | null {
    const userId = localStorage.getItem('UserId') || localStorage.getItem('userId');
    const decryptedOrgId = this.util?.decrypt(localStorage.getItem('OrgId'));
    const orgId = decryptedOrgId || localStorage.getItem('OrganizationId') || localStorage.getItem('OrgId');

    return buildTableColumnPreferencesKey({
      userId,
      orgId,
      moduleType: this.moduleType,
      pageType: this.columnPreferencePageType || this.pageType
    });
  }

  private getLegacyColumnPreferencesKey(): string | null {
    const userId = localStorage.getItem('UserId') || localStorage.getItem('userId');
    const orgId = localStorage.getItem('OrgId') || localStorage.getItem('OrganizationId');

    return buildTableColumnPreferencesKey({
      userId,
      orgId,
      moduleType: this.moduleType,
      pageType: this.columnPreferencePageType || this.pageType
    });
  }

  private normalizeVisibleColumns(columns: string[], columnsSource: TableColumn[] = this.tableColumns): string[] {
    if (!Array.isArray(columns)) {
      return [];
    }

    const requestedColumns = new Set(columns.filter((column): column is string => typeof column === 'string'));
    const fixedColumns = new Set(
      columnsSource
        .filter(col => !this.isIgnoredColumn(col.name) && (col.select || this.fixedVisibleColumns.has(col.name)))
        .map(col => col.name)
    );

    return columnsSource
      .map(col => col.name)
      .filter(columnName => !this.isIgnoredColumn(columnName))
      .filter(columnName => requestedColumns.has(columnName) || fixedColumns.has(columnName));
  }

  private rebuildTreeDropdownColumns(): void {
    const isAssessmentPlanPage = this.moduleType === 'operations' && this.pageType === 'assessments';
    this.treeDropdownColumns = this.allColumnNames
      .filter(col => !this.isIgnoredColumn(col) && !(col.toLowerCase().includes('id') && !col.toLowerCase().includes('candidate') && !(isAssessmentPlanPage && col.toLowerCase() === 'assessment id')))
      .map(col =>
        new TreeviewItem({
          text: col,
          value: col,
          checked: this.visibleColumns.includes(col),
          disabled: ['S.No.', 'Status', 'Actions'].includes(col)
        })
      );
  }

  private getDynamicColumnInsertIndex(): number {
    const statusIndex = this.tableColumns.findIndex(column => column.name === 'Status');
    if (statusIndex !== -1) {
      return statusIndex;
    }

    const actionsIndex = this.tableColumns.findIndex(column => column.name === 'Actions');
    if (actionsIndex !== -1) {
      return actionsIndex;
    }

    return this.tableColumns.length;
  }

  private ensureVisibleColumnsExistInTableColumns(columns: string[]): void {
    const existingColumns = new Set(this.tableColumns.map(column => column.name));

    columns.forEach((columnName) => {
      if (this.isIgnoredColumn(columnName)) {
        return;
      }
      if (!existingColumns.has(columnName)) {
        this.tableColumns.splice(this.getDynamicColumnInsertIndex(), 0, this.buildDynamicColumn(columnName));
        existingColumns.add(columnName);
      }
    });
  }

  private captureBaseColumns(columns?: TableColumn[]): void {
    if (columns && Array.isArray(columns)) {
      this.baseTableColumns = this.cloneTableColumns(columns);
      return;
    }

    if (!this.baseTableColumns.length && Array.isArray(this.tableColumns) && this.tableColumns.length > 0) {
      this.baseTableColumns = this.cloneTableColumns(this.tableColumns);
    }
  }

  private getBaseTableColumns(): TableColumn[] {
    if (this.baseTableColumns.length) {
      return this.baseTableColumns;
    }

    return Array.isArray(this.tableColumns) ? this.tableColumns : [];
  }

  private cloneTableColumns(columns: TableColumn[]): TableColumn[] {
    return JSON.parse(JSON.stringify(columns || []));
  }

  private buildDynamicColumn(columnName: string): TableColumn {
    if (columnName.toLowerCase() === 'select') {
      return {
        name: columnName,
        select: true,
        position: 'left',
        isSortable: false,
        type: 'text'
      };
    }

    const lowerName = columnName.toLowerCase();
    let resolvedType: TableColumn['type'] = 'text';

    if (lowerName.includes('datetime')) {
      resolvedType = 'date';
    } else if (lowerName.includes('tag')) {
      resolvedType = 'tags';
    }

    return {
      name: columnName,
      dataKey: columnName.replace(/\s+/g, '_').toLowerCase(),
      position: 'left',
      isSortable: true,
      isDefault: false,
      type: resolvedType
    };
  }

  // Update displayedColumns for table
updateDisplayedColumns() {

  //for Question page
  if (this.moduleType === 'questions' || this.pageType === 'question banks') {
    const selectColumnNames = this.tableColumns
      .filter(col => col.select)
      .map(col => col.name?.toString());

    let selectColumnName: string | null = null;
    for (const candidate of selectColumnNames) {
      if (!candidate) continue;
      const found = this.visibleColumns.find(
        col => col?.toString()?.trim().toLowerCase() === candidate.trim().toLowerCase()
      );
      if (found) {
        selectColumnName = found;
        break;
      }
    }

    if (!selectColumnName) {
      selectColumnName = this.visibleColumns.find(
        col => col?.toString()?.trim().toLowerCase() === 'select'
      );
    }

    if (selectColumnName) {
      let otherCols = this.visibleColumns.filter(col => col !== selectColumnName);

      //ensure S.No. second
      const snoIndex = otherCols.findIndex(
        col => col?.toString()?.trim().toLowerCase() === 's.no.'
      );

      if (snoIndex !== -1) {
        const [snoCol] = otherCols.splice(snoIndex, 1);
        this.displayedColumns = [selectColumnName, snoCol, ...otherCols];
      } else {
        this.displayedColumns = [selectColumnName, ...otherCols];
      }

    } else {
      this.displayedColumns = [...this.visibleColumns];
    }

  } else {
    const hasSelectColumn = this.visibleColumns.includes('select');
    if (hasSelectColumn) {
      // If select exists, ensure it's first
      const otherCols = this.visibleColumns.filter(col => col !== 'select');
      this.displayedColumns = ['select', ...otherCols];
    } else {
      // If no select column, just use visibleColumns as is
      this.displayedColumns = [...this.visibleColumns];
    }
    }
  }

  private getRowKey(row: any): string | number | null {
    if (!row) return null;
    return row.question_id ?? row.id ?? row.questionId ?? row?.id;
  }

  private restoreSelectionForCurrentPage(): void {
    if (!this.tableDataSource?.data) return;
    this.selection.clear();
    if (!Array.isArray(this.selectedItems) || this.selectedItems.length === 0) return;

    const selectedKeySet = new Set(this.selectedItems.map(item => this.getRowKey(item)).filter(k => k !== null));
    const rowsToSelect = this.tableDataSource.data.filter(row => selectedKeySet.has(this.getRowKey(row)));
    if (rowsToSelect.length > 0) {
      this.selection.select(...rowsToSelect);
    }
  }

  private mergeSelectedItemsByKey(currentPageRows: any[], add: boolean): void {
    const currentIds = new Set(currentPageRows.map(row => this.getRowKey(row)).filter(k => k !== null));
    const selectedByKey = new Map<string | number, any>();
    if (Array.isArray(this.selectedItems)) {
      this.selectedItems.forEach(item => {
        const key = this.getRowKey(item);
        if (key !== null) selectedByKey.set(key, item);
      });
    }

    if (add) {
      currentPageRows.forEach(row => {
        const key = this.getRowKey(row);
        if (key !== null && !selectedByKey.has(key)) {
          selectedByKey.set(key, row);
        }
      });
    } else {
      currentIds.forEach(key => selectedByKey.delete(key));
    }

    this._selectedItems = Array.from(selectedByKey.values());
  }
 toggleAllRows() {
  if (this.moduleType === 'questions' || this.pageType === 'question banks') {

    const currentPageRows = this.tableDataSource.data || [];

    if (this.isAllSelected() && currentPageRows.length > 0) {
      this.selection.clear();
      this.mergeSelectedItemsByKey(currentPageRows, false);
    } else {
      this.selection.select(...currentPageRows);
      this.mergeSelectedItemsByKey(currentPageRows, true);
    }

    this.restoreSelectionForCurrentPage();
    this.selectedItemsChange.emit(this.selectedItems);

  } else if (this.serverSidePagination) {
    // For server-side pagination: select/deselect only the current page, preserve cross-page selections
    const currentPageData = this.tableDataSource.data;
    const currentPageIds = new Set(currentPageData.map((row: any) => row.id));
    if (this.isAllSelected()) {
      // Deselect only current page — keep off-page selections intact
      this.selection.clear();
      this._selectedItems = this._selectedItems.filter((item: any) => !currentPageIds.has(item.id));
    } else {
      // Select all on current page, merge with off-page selections
      this.selection.select(...currentPageData);
      const offPage = this._selectedItems.filter((item: any) => !currentPageIds.has(item.id));
      this._selectedItems = [...offPage, ...currentPageData];
    }
    this.selectedItemsChange.emit(this._selectedItems);
  } else {
    if (this.isAllSelected()) {
      this.selection.clear();
      this.selectedItems = [];
    } else {
      this.selection.select(...this.tableDataSource.data);
      this.selectedItems = [...this.selection.selected];
    }
    this.selectedItemsChange.emit(this.selection.selected);
  }
}

 checkboxLabel(row?: any): string {
  if (this.moduleType === 'questions' || this.pageType === 'question banks') {
    if (!row) {
    const label = this.selectAllMode === 'all'? 'select all across pages': 'select all visible page';
     return `${this.isAllSelected() ? 'deselect' : 'select'} ${label}`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;

  }
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

  showFullContent(content: string, title: string) {
    // Handle both HTML content and plain text
    if (content) {
      // If content contains HTML tags, preserve them; otherwise convert newlines to br
      this.fullContent = content.includes('<') 
        ? content 
        : content.replace(/\n/g, "<br>");
    } else {
      this.fullContent = '';
    }
    this.fullContentTitle = title;
    $("#viewFullContentModal").modal("show");
  }

  setTableDataSource(data: any) {
    // console.log('tableData', data);
    // console.log('🎨 setTableDataSource - rootLabelColors check:', data.map(d => ({ id: d.question_id || d.id, colors: d.rootLabelColors })));
    this.originalTableData = data;
    this.tableDataSource = new MatTableDataSource(this.originalTableData);

    if (this.matPaginator && this.moduleType !== 'questions' && this.pageType !== 'question banks' && !this.serverSidePagination) {
      this.tableDataSource.paginator = this.matPaginator;
    }
    
    // Pre-select rows ONLY if enablePreSelection is true and selectedItems were provided
    if (this.enablePreSelection && this.selectedItems && this.selectedItems.length > 0) {

    if (this.moduleType === 'questions' || this.pageType === 'question banks') {
      this.restoreSelectionForCurrentPage();

    } else {
      const currentData = this.tableDataSource.data;
      // Match on any of the id/candidate_id permutations so selections carry
      // across data shapes from different sources.
      const selectedRows = currentData.filter(row =>
        this.selectedItems.some(selected =>
          selected.id == row.id ||
          selected.candidate_id == row.id ||
          selected.id == row.candidate_id ||
          (selected.candidate_id && row.candidate_id && selected.candidate_id == row.candidate_id)
        )
      );
      setTimeout(() => this.selection.select(...selectedRows), 50);
    }
}
    
    const startDate = new Date(new Date().setDate(new Date().getDate() - 30));
    const endDate = new Date();
    this.range = new FormGroup({
      start: new FormControl(startDate),
      end: new FormControl(endDate),
    });
    // const filter = this.filterAttributes?.find((item: any) => item.type === 'date');
    // if (filter) {
    //   this.onSelect({
    //     datakey: filter.dataKeyName,
    //     name: filter.name,
    //     option: constants.BETWEEN,
    //     type: constants.DATE,
    //     start: startDate,
    //     end: endDate,
    //   });
    // }
  }

  // Table component mein yeh method add karein
shouldShowTooltip(text: string): boolean {
  if (!text) return false;
  
  // Strip HTML tags for accurate length calculation
  const strippedText = this.stripHtml(text);
  
  // Check if text will be truncated in the cell
  // Assume cell max width is around 200px, average character width is 8px
  const maxVisibleChars = 25; // Adjust based on your column width
  
  // Also check for multiline text
  const hasMultipleLines = strippedText.includes('\n') || strippedText.length > 100;
  
  return strippedText.length > maxVisibleChars || hasMultipleLines;
}

// Strip HTML tags properly
private stripHtml(html: string): string {
  if (html === null || html === undefined || html === '') return '';
  const str = typeof html === 'string' ? html : String(html);
  if (!str) return '';
  return str
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/gi, "'")
    .replace(/\s+/g, ' ')
    .trim();
}

// Get full text for tooltip
getFullText(text: string): string {
  if (!text) return '';
  
  // First strip HTML
  const stripped = this.stripHtml(text);
  
  // If still too long, truncate for tooltip
  if (stripped.length > 500) {
    return stripped.substring(0, 500) + '...';
  }
  
  return stripped;
}

// Capitalize first letter of text
capitalizeFirstLetter(text: string): string {
  if (!text || typeof text !== 'string') return '';
  return text.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
}

// Format text cell value, preserving original casing for case-sensitive columns like email
formatCellText(text: string, tableColumn: any): string {
  if (!text || typeof text !== 'string') return text || '';
  const dataKey = (tableColumn?.dataKey || '').toLowerCase();
  if (dataKey === 'email' || dataKey.includes('email')) {
    return text;
  }
  return this.capitalizeFirstLetter(text);
}

countButtonClick(name: any, row: any) {
  if (name === 'Details') {
    this.openModal(row);
  } else {
    this.countButtonEmitter.emit({ name: name, row: row });
  }
}

openModal(element: any) {
  if (this.richTextClick.observers.length > 0) {
    this.richTextClick.emit(element);
    return;
  }

  if (this.dialogRef) {
    this.dialogRef.close();
  }

  const initialDetails = this.prepareQuestionDetails(element);

  this.dialogRef = this.dialog.open(NonedittextboxComponent, {
    width: '900px',
    maxHeight: '85vh',
    panelClass: 'question-details-modal',
    hasBackdrop: true,
    disableClose: false,
    autoFocus: false,
    data: { 
      element: element,
      details: initialDetails,
      title: `Question Details`,
      prepareDetailsMethod: this.prepareQuestionDetails.bind(this)
    },
  });
  const QuestionId = localStorage.getItem('QuestionId');
  const UserRoleId = localStorage.getItem('UserRoleId');
  
  const postData = {
    questionId: element?.question_id ?? 0,   
    questionBankId: QuestionId ? parseInt(QuestionId, 10) : 0,
    userRoleId: UserRoleId ? parseInt(UserRoleId, 10) : 0,
    orgId: this.OrganizationId ? parseInt(this.OrganizationId, 10) : 0
  };

  this.getService.get('questionData', postData).subscribe(
    (data: any) => {
      const allQuestions = data.body.responseBody || [];
      let relatedQuestions: any[] = [];
      // Get fresh data from API for the main element
      const elementFromAPI = allQuestions.find((q: any) => q.question_id === element.question_id) || element;
      
      // console.log('=== QUESTION DETAILS MODAL OPENED ===');
      // console.log('Question ID:', elementFromAPI.question_id);
      // console.log('Question Text:', elementFromAPI.question_text);
      // console.log('Labels Data:', elementFromAPI.labels);
      // console.log('Course ID:', elementFromAPI.course_id);
      // console.log('Version ID:', elementFromAPI.version_id);
      
      // Check if this question is a PARENT (parent_id === -1)
      if (element.parent_id === -1) {
        const childQuestions = allQuestions.filter((q: any) => q.parent_id === element.question_id);
        relatedQuestions = [elementFromAPI, ...childQuestions];
      } 
      // Check if this question is a CHILD (has parent_id !== -1)
      else if (element.parent_id && element.parent_id !== -1) {
        const parentQuestion = allQuestions.find((q: any) => q.question_id === element.parent_id);
        if (parentQuestion) {
          relatedQuestions.push(parentQuestion);
        }
        const siblingQuestions = allQuestions.filter((q: any) => 
          q.parent_id === element.parent_id && q.question_id !== element.question_id
        );
        relatedQuestions.push(elementFromAPI, ...siblingQuestions);
      }
      else {
        relatedQuestions = [elementFromAPI];
      }
       // Filter out inactive (removed) language translations
      relatedQuestions = relatedQuestions.filter((q: any) => q.is_active !== false);
      
      // Deduplicate by language_id for MCQ and Multi-select — keep the first occurrence per language
       const seenLanguageIds = new Set<number>();
      relatedQuestions = relatedQuestions.filter((q: any) => {
        if (seenLanguageIds.has(q.language_id)) return false;
        seenLanguageIds.add(q.language_id);
        return true;
      });


      // ALWAYS update the dialog with fresh question details first
      // This ensures Question Specific Details shows even for questions without labels
      if (this.dialogRef) {
        this.dialogRef.componentInstance.element = elementFromAPI;
        this.dialogRef.componentInstance.relatedQuestions = relatedQuestions;
        this.dialogRef.componentInstance.currentLanguageId = element.question_id;
        
        // Use English (parent) option count as the reference limit for all languages
        const parentQ = relatedQuestions.find((q: any) => q.parent_id === -1);
        const parentOptionCount = parentQ?.question_options?.length ?? null;

        const trimToPrimaryCount = (q: any): any => {
          if (
            parentOptionCount !== null &&
            q.parent_id !== -1 &&
            q.question_options &&
            q.question_options.length > parentOptionCount
          ) {
            const sorted = [...q.question_options].sort((a: any, b: any) =>
              (a.order_index || a.id || 0) - (b.order_index || b.id || 0)
            );
            return { ...q, question_options: sorted.slice(0, parentOptionCount) };
          }
          return q;
        };

        const allQuestionDetails: any = {};
        relatedQuestions.forEach((q: any) => {
          allQuestionDetails[q.question_id] = this.prepareQuestionDetails(trimToPrimaryCount(q));
        });
        this.dialogRef.componentInstance.allQuestionDetails = allQuestionDetails;
        
        const freshElement = elementFromAPI;
        const freshDetails = this.prepareQuestionDetails(freshElement);
        this.dialogRef.componentInstance.updateWithFreshDetails(freshDetails, freshElement);
      }
      
      // Now fetch and enrich labels if they exist
      if (elementFromAPI.labels && elementFromAPI.labels.length > 0) {
        // Use the correct service call - same as in addquestion component
        const courseId = elementFromAPI.course_id;
        const versionId = elementFromAPI.version_id;
        
        this.contentLabelService.getAllContentLabels(courseId, versionId).subscribe(
          (apiResponse: any) => {
            const allLabelsFromAPI = apiResponse.body?.responseBody || apiResponse.body || [];
            console.log('All Labels from API (count):', allLabelsFromAPI.length);
            
            // Create enriched label data with API label names for elementFromAPI
            const enrichedLabels = elementFromAPI.labels?.map((group: any) => ({
              ...group,
              labels: group.labels?.map((label: any) => {
                const matchedLabel = allLabelsFromAPI.find((apiLabel: any) => 
                  apiLabel.id === label.labelId || apiLabel.label_id === label.labelId
                );
                
                console.log(`  └─ Label:`, {
                  labelId: label.labelId,
                  labelName: label.labelName,
                  level: label.level,
                  parentLabelId: label.parentLabelId,
                  matchedFromAPI: matchedLabel ? {
                    id: matchedLabel.id,
                    label_name: matchedLabel.label_name,
                    label_index: matchedLabel.label_index,
                    parent_label_id: matchedLabel.parent_label_id
                  } : 'NOT FOUND'
                });
                
                // Enrich label with API data
                return {
                  ...label,
                  apiLabelName: matchedLabel?.label_name || label.labelName,
                  apiLabelInfo: matchedLabel ? {
                    id: matchedLabel.id,
                    label_name: matchedLabel.label_name,
                    label_index: matchedLabel.label_index,
                    parent_label_id: matchedLabel.parent_label_id
                  } : null
                };
              }) || []
            })) || [];
            
            // Update elementFromAPI with enriched labels
            elementFromAPI.labels = enrichedLabels;
            elementFromAPI.enrichedLabelsForDisplay = enrichedLabels;
            
            // Also enrich all relatedQuestions with API label names
            relatedQuestions = relatedQuestions.map((q: any) => {
              if (q.labels && q.labels.length > 0) {
                const enrichedRelatedLabels = q.labels.map((group: any) => ({
                  ...group,
                  labels: group.labels?.map((label: any) => {
                    const matchedLabel = allLabelsFromAPI.find((apiLabel: any) => 
                      apiLabel.id === label.labelId || apiLabel.label_id === label.labelId
                    );
                    
                    return {
                      ...label,
                      apiLabelName: matchedLabel?.label_name || label.labelName,
                      apiLabelInfo: matchedLabel ? {
                        id: matchedLabel.id,
                        label_name: matchedLabel.label_name,
                        label_index: matchedLabel.label_index,
                        parent_label_id: matchedLabel.parent_label_id
                      } : null
                    };
                  }) || []
                }));
                
                return {
                  ...q,
                  labels: enrichedRelatedLabels,
                  enrichedLabelsForDisplay: enrichedRelatedLabels
                };
              }
              return q;
            });
            
            console.log('=== END LABELS DATA ===');
            
            // Update the dialog with enriched label data
             if (this.dialogRef) {
              const updatedAllQuestionDetails: any = {};
              relatedQuestions.forEach((q: any) => {
                updatedAllQuestionDetails[q.question_id] = this.prepareQuestionDetails(q);
              });
              this.dialogRef.componentInstance.allQuestionDetails = updatedAllQuestionDetails;
              const freshElement = elementFromAPI;
              const freshDetails = this.prepareQuestionDetails(freshElement);
              this.dialogRef.componentInstance.updateWithFreshDetails(freshDetails, freshElement);
            }
          },
          (err: any) => {
            console.log('Failed to fetch labels from API:', err);
          }
        );
      } else {
        console.log('No labels found for this question');
        console.log('=== END LABELS DATA ===');
      }
    },
    (err: any) => {
      console.log('Failed to fetch related questions');
    }
  );
}

prepareQuestionDetails(element: any): any {
  // Log actual option structure to see all properties
  if (element.question_options && element.question_options.length > 0) {
    element.question_options.forEach((opt: any, idx: number) => {
      console.log(`Option ${idx}:`, opt);
    });
  }  
  // Helper function to format date
  const formatDate = (dateString: string | null): string => {
    if (!dateString) return 'Never';
    try {
      // For ISO format with Z (UTC), parse directly without timezone conversion
      if (dateString.includes('T') && dateString.includes('Z')) {
        // ISO format: "2025-12-30T18:41:00.201Z"
        // Extract date and time components directly from the string
        const isoRegex = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})/;
        const match = dateString.match(isoRegex);
        
        if (match) {
          const year = parseInt(match[1]);
          const month = parseInt(match[2]);
          const day = parseInt(match[3]);
          const hours = parseInt(match[4]);
          const minutes = parseInt(match[5]);
          const seconds = parseInt(match[6]);
          
          // Convert month number to month name
          const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
          const monthName = monthNames[month - 1];
          
          // Convert to 12-hour format
          const ampm = hours >= 12 ? 'pm' : 'am';
          const hours12 = hours % 12 || 12; // Convert 0 to 12, 13 to 1, etc.
          const hoursStr = String(hours12).padStart(2, '0');
          const minutesStr = String(minutes).padStart(2, '0');
          const secondsStr = String(seconds).padStart(2, '0');
          const dayStr = String(day).padStart(2, '0');
          
          const formattedDate = `${dayStr} ${monthName} ${year} ${hoursStr}:${minutesStr}:${secondsStr} ${ampm}`;
          
          // console.log('ISO DateTime Input:', dateString);
          // console.log('Extracted Components - Day:', dayStr, 'Month:', monthName, 'Year:', year, 'Time:', `${hoursStr}:${minutesStr}:${secondsStr} ${ampm}`);
          // console.log('Formatted Date Output:', formattedDate);
          
          return formattedDate;
        }
      }
      
      // Fallback for other date formats
      let date: Date;
      if (dateString.includes('-') && !dateString.includes(':')) {
        // Date only format: "30-Dec-2025" or "2025-12-30"
        date = new Date(dateString);
      } else {
        date = new Date(dateString);
      }
      
      // Check if date is valid
      if (isNaN(date.getTime())) {
        console.warn('Invalid date detected:', dateString);
        return 'Invalid date';
      }
      
      // Format date part
      const day = String(date.getDate()).padStart(2, '0');
      const month = date.toLocaleDateString('en-IN', { month: 'short' });
      const year = date.getFullYear();
      
      // Format time part
      let hours = date.getHours();
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      const ampm = hours >= 12 ? 'pm' : 'am';
      hours = hours % 12;
      hours = hours ? hours : 12; // 0 hours should be 12
      const hoursStr = String(hours).padStart(2, '0');
      
      return `${day} ${month} ${year} ${hoursStr}:${minutes}:${seconds} ${ampm}`;
    } catch (e) {
      console.error('Date format error:', dateString, e);
      return 'Invalid date';
    }
  };

  // Format attachments - FIXED: Use the full URL from the backend
  let attachmentsDisplay = 'None';
  if (element.attachments) {
    console.log('📎 Raw attachments data from backend:', element.attachments);
    
    // Check if it's a string (could be single URL or comma-separated URLs)
    if (typeof element.attachments === 'string') {
      const attachmentArray = element.attachments.split(',').filter((url: string) => url.trim());
     // console.log('📎 Parsed attachment URLs:', attachmentArray);
      
      if (attachmentArray.length > 0) {
        attachmentsDisplay = attachmentArray.map((fullUrl: string, index: number) => {
          const fileName = fullUrl.split('/').pop() || 'Attachment';
          
          return `<a href="${fullUrl.trim()}" target="_blank" style="color: #0066cc; text-decoration: none; cursor: pointer;">
                    ${fileName}
                  </a>`;
        }).join('<br>');
      }
    }
  }

  // Format labels - Prepare for collapsible tree structure
let labelsDisplay = 'None';
if (element.labels && element.labels.length > 0) {
  // Pass raw labels data for collapsible display
  const labelsData = element.labels;
  if (labelsData && labelsData.length > 0) {
    // Mark this as special labels data that should be rendered as collapsible tree
    labelsDisplay = JSON.stringify({
      isCollapsibleLabels: true,
      data: labelsData
    });
  }
}

  // Format tags
  let tagsDisplay = 'None';  
  if (element.tags) {
    try {
      const parsedTags = typeof element.tags === 'string' ? JSON.parse(element.tags) : element.tags;
      if (Array.isArray(parsedTags) && parsedTags.length > 0) {
        tagsDisplay = parsedTags.map((tag: any) => {
          // If tag has id only, lookup from cache
          if (tag.id && !tag.key) {
            const cachedTag = this.tagsCache.get(tag.id);
            if (cachedTag) {
              return `${cachedTag.key}: ${cachedTag.value}`;
            } else {
              return `Tag(${tag.id})`;
            }
          }
          // If tag already has key and value, use it directly
          if (tag.key && tag.value) {
            return `${tag.key}: ${tag.value}`;
          }
          return '';
        }).filter(t => t).join(' ');
      } 
    } catch (e) {
    }
  } 

  // Get question type-specific display
  const questionTypeDisplay = this.getQuestionTypeSpecificDisplay(element);

  // Get created by full name or username from element or localStorage
  const createdByUsername = (element.created_user_name && element.created_user_name !== 'system' && element.created_user_name !== '')
    ? element.created_user_name
    : (element.created_user && element.created_user !== 'system' && element.created_user !== '')
      ? element.created_user
      : (element.created_user_username && element.created_user_username !== 'system' && element.created_user_username !== '')
        ? element.created_user_username
        : localStorage.getItem('full_name') || localStorage.getItem('fullname') || localStorage.getItem('username') || 'Unknown';

  const detailedResults = {
    // Basic Information
    'Question Text': element.question_text || 'No question text available',
    'Question Type': element.question_type_name || 'N/A',
    'Difficulty Level': element.difficulty_level_name || 'N/A',
    'Evaluation Mode': element.question_category || 'N/A',
    'Language': element.language_name || 'English',

    // Course/Version Information
    'Course/Job Role': element.course_name || 'N/A',
    'Course Code': element.course_code || 'N/A',
    'Version': element.version || 'N/A',

    // Question Type Specific Information
    ...questionTypeDisplay,

    // Additional Information
    'Additional Information': element.additional_information || 'None',
    'Question Hint': element.question_hint || 'None',
    'Question Feedback': element.question_feedback || 'None',
    'Question Remarks': element.question_remarks || 'None',

    // Files and Metadata
    'Attachments': attachmentsDisplay,
    'Labels': labelsDisplay,
    'Tags': tagsDisplay,

    // Status and Dates
    'Status': element.is_active ? 'Active' : 'Inactive',
    'Archived': element.is_archived ? 'Yes' : 'No',
    'Created Date': formatDate(element.created_datetime),
    'Modified Date': formatDate(element.modified_datetime),
    'Created By': createdByUsername
  };  
  return detailedResults;
}
getCleanRichText(html: string): string {
  if (!html) return '';
  // const temp = document.createElement('div');
  // temp.innerHTML = html;

  if (this.truncateRichText) {
    const withoutMedia = html.replace(/<(img|video|iframe|table)[^>]*>[\s\S]*?<\/\1>|<(img|video|iframe)[^>]*\/?>/gi, '');
    const textContent = withoutMedia.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();
    const maxLength = 100;
    return textContent.length > maxLength ? textContent.substring(0, maxLength) + '...' : textContent;
  }

  // const blocks = Array.from(temp.querySelectorAll('p, div, li, h1, h2, h3, h4, h5, h6'));
  // blocks.forEach(block => {
  //   // Clone and remove images to check what text remains
  //   const clone = block.cloneNode(true) as HTMLElement;
  //   Array.from(clone.querySelectorAll('img')).forEach(img => img.remove());

  //   const remainingText = (clone.textContent || '').trim();
  //   const remainingHtml = clone.innerHTML.trim();
  //   const isEmptyOrBrOnly =
  //     remainingText === '' &&
  //     (remainingHtml === '' || /^(<br\s*\/?>|\s)*$/i.test(remainingHtml));

  //   // Remove if block has no real text (empty, br-only, or image-only)
  //   if (isEmptyOrBrOnly) {
  //     block.remove();
  //   }
  // });

  return html;
}

// Get truncated HTML text while preserving HTML structure
getTruncatedText(text: string, limit: number = 120): string {
  if (!text) return '';
  
  // Get stripped text length for comparison
  const strippedText = text.replace(/<[^>]*>/g, '');
  
  if (strippedText.length <= limit) {
    return text;
  }
  
  // For HTML content, return original and let CSS handle truncation
  return text;
  // Truncate and add ellipsis
  const truncated = strippedText.substring(0, limit);

  // Try to truncate at word boundary
  const lastSpace = truncated.lastIndexOf(' ');
  const finalText = lastSpace > limit * 0.7 ? 
                    truncated.substring(0, lastSpace) : 
                    truncated;

  return finalText + '...';
}


// Filter matching table options to show only the most recent version
private getLatestMatchingTableOptions(options: any[]): any[] {
  if (!options || options.length === 0) return options;

  // Group by (is_primary_list, list_order_id) and keep only the one with highest ID
  const grouped: { [key: string]: any } = {};

  options.forEach(option => {
    const groupKey = `${option.is_primary_list}_${option.list_order_id}`;
    if (!grouped[groupKey] || option.id > grouped[groupKey].id) {
      grouped[groupKey] = option;
    }
  });

  return Object.values(grouped).sort((a, b) => {
    if (a.is_primary_list === b.is_primary_list) {
      return a.list_order_id - b.list_order_id;
    }
    return a.is_primary_list ? -1 : 1;
  });
}

getQuestionTypeSpecificDisplay(element: any): any {
  const questionType = element.question_type_id;
  const questionTypeName = element.question_type_name || '';
  const result: any = {};

  // Helper function to extract and clean URL from various formats
  const extractCleanUrl = (attachment: any): string => {
    let url = '';
    
    if (typeof attachment === 'string') {
      try {
        // Try to parse as JSON first
        const parsed = JSON.parse(attachment);
        if (typeof parsed === 'string') {
          url = parsed;
        }
      } catch (e) {
        // Not JSON, use as-is
        url = attachment;
      }
    }
    
    if (url) {
      // Clean up the URL thoroughly
      url = url
        .trim()
        .replace(/[{}\"]/g, '')  // Remove JSON special chars
        .replace(/\\/g, '')      // Remove backslashes
        .replace(/^\//, '')      // Remove leading slash
        .trim();
      
      // Validate that it looks like a URL or path
      if (url && (url.includes('http') || url.includes('s3.') || url.includes('/'))) {
        return url;
      }
    }
    
    return '';
  };

  // Check if it's a practical question - show KPI records instead of options
  const isPracticalQuestion = element.question_category === 'practical';
const sortById = (a: any, b: any) => {
  const idA = a.kpi_id || a.id || 0;
  const idB = b.kpi_id || b.id || 0;
  return idA - idB; // Chote se bade ID ke sequence mein sort karega
};
  const shouldShowObservationScore = (kpi: any): boolean =>
    (Number(kpi?.observation_score) || 0) > 0;
  const shouldShowVivaScore = (kpi: any): boolean =>
    (Number(kpi?.viva_score) || 0) > 0;
  const renderKpiTable = (kpis: any[], headerColor: string, headerTextColor: string): string => {
    const showObservationColumn = Array.isArray(kpis) && kpis.some((kpi: any) => shouldShowObservationScore(kpi));
    const showVivaColumn = Array.isArray(kpis) && kpis.some((kpi: any) => shouldShowVivaScore(kpi));

    return `<table style="width: 100%; border-collapse: collapse; margin: 10px 0;">
      <thead>
        <tr style="background-color: ${headerColor}; color: ${headerTextColor};">
          <th style="padding: 10px; text-align: left; border: 1px solid #ddd;">KPI Name</th>
          <th style="padding: 10px; text-align: center; border: 1px solid #ddd;">KPI Score</th>
          ${showObservationColumn ? '<th style="padding: 10px; text-align: center; border: 1px solid #ddd;">Observation Score</th>' : ''}
          ${showVivaColumn ? '<th style="padding: 10px; text-align: center; border: 1px solid #ddd;">Viva Score</th>' : ''}
        </tr>
      </thead>
      <tbody>
        ${kpis.map((kpi: any) => `
          <tr style="background-color: #f8f9fa;">
            <td style="padding: 10px; border: 1px solid #ddd;">${kpi.kpi_name || 'N/A'}</td>
            <td style="padding: 10px; text-align: center; border: 1px solid #ddd;">${kpi.kpi_score || 'N/A'}</td>
            ${showObservationColumn ? `<td style="padding: 10px; text-align: center; border: 1px solid #ddd;">${shouldShowObservationScore(kpi) ? (kpi.observation_score ?? 0) : 'N/A'}</td>` : ''}
            ${showVivaColumn ? `<td style="padding: 10px; text-align: center; border: 1px solid #ddd;">${shouldShowVivaScore(kpi) ? (kpi.viva_score ?? 0) : 'N/A'}</td>` : ''}
          </tr>
        `).join('')}
      </tbody>
    </table>`;
  };
  const getOptionOrder = (option: any, fallback: number = 0): number => {
    if (!option) return fallback;
    const values = [option.list_order_id, option.option_order, option.sequence, option.order, option.id, fallback];
    for (const v of values) {
      if (v !== undefined && v !== null && !Number.isNaN(Number(v))) {
        return Number(v);
      }
    }
    return fallback;
  };

  const getSortedOptions = (options: any[]): any[] => {
    if (!Array.isArray(options)) return [];
    return [...options].sort((a, b) => {
      const orderA = getOptionOrder(a, 0);
      const orderB = getOptionOrder(b, 0);
      if (orderA !== orderB) return orderA - orderB;
      const textA = (a.option_text || a.label || '').toString().toLowerCase();
      const textB = (b.option_text || b.label || '').toString().toLowerCase();
      if (textA < textB) return -1;
      if (textA > textB) return 1;
      return (a.id || 0) - (b.id || 0);
    });
  };

  const dedupeOptionsByOrder = (options: any[]): any[] => {
    if (!Array.isArray(options)) return [];
    const dedupeMap = new Map<number, any>();
    getSortedOptions(options).forEach((opt: any) => {
      const orderKey = Number(opt.list_order_id ?? opt.option_order ?? opt.sequence ?? opt.id ?? 0);
      if (!dedupeMap.has(orderKey)) {
        dedupeMap.set(orderKey, opt);
      } else {
        const existing = dedupeMap.get(orderKey);
        if ((opt.modified_datetime && new Date(opt.modified_datetime).getTime() > new Date(existing.modified_datetime || 0).getTime()) || (opt.id && existing.id && opt.id > existing.id)) {
          dedupeMap.set(orderKey, opt);
        }
      }
    });
    return Array.from(dedupeMap.entries())
      .sort(([a], [b]) => a - b)
      .map(([, value]) => value);
  };
  const renderListValueAttachmentsForKey = (attachmentsObj: any, itemKey: string): string => {
    if (!attachmentsObj) {
      return '';
    }

    let rawValue = attachmentsObj[itemKey];
    if (!rawValue) {
      return '';
    }

    let urls: string[] = [];
    if (Array.isArray(rawValue)) {
      urls = rawValue.map((att: any) => extractCleanUrl(att)).filter((url: string) => url !== '');
    } else if (typeof rawValue === 'string') {
      urls = rawValue
        .split(/[,;]/)
        .map((att: string) => extractCleanUrl(att))
        .filter((url: string) => url !== '');
    } else {
      const extracted = extractCleanUrl(rawValue);
      if (extracted) {
        urls = [extracted];
      }
    }

    if (urls.length === 0) {
      return '';
    }

    const linksHtml = urls.map((url: string) => {
      const fullUrl = url.includes('http') ? url : `https://${url}`;
      const fileName = fullUrl.split('/').pop() || `Attachment ${itemKey}`;
      return `<a href="${fullUrl}" target="_blank" style="color: #0066cc; text-decoration: none; display: block; margin-top: 4px; padding-left: 24px;">📎 ${fileName}</a>`;
    }).join('');

    return `<div style="margin: 0; padding: 0 0 0 24px; font-size: 12px;">${linksHtml}</div>`;
  };

  switch (questionType) {
    case 1: // Multiple Choice Question
      // Skip options if it's a practical question
      if (isPracticalQuestion && element.kpi_records && element.kpi_records.length > 0) {
        const sortedKpis = [...element.kpi_records].sort(sortById);
        result['KPI Records'] = renderKpiTable(sortedKpis, '#0066cc', 'white');
      } else if (element.question_options && element.question_options.length > 0) {
        // FIX: Don't filter out options - show ALL options for all languages
        // Group options by option ID to show all language versions
        const groupedOptions: { [key: number]: any[] } = {};
        
        element.question_options.forEach((option: any) => {
          const optionId = option.id || option.option_id;
          if (!groupedOptions[optionId]) {
            groupedOptions[optionId] = [];
          }
          groupedOptions[optionId].push(option);
        });
        
        // Display each option with all its language versions
        let optionsHtml = '';
        let optionIndex = 1;
        
        for (const optionId in groupedOptions) {
          const optionVersions = groupedOptions[optionId];
          
          optionsHtml += `<div style="margin-bottom: 12px; padding: 12px; border-left: 3px solid ${optionVersions[0].is_correct_option ? '#28a745' : '#dc3545'}; border-radius: 2px;">`;
          
          optionsHtml += `<div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 8px;">
            <div>
              <strong>Option ${optionIndex}:</strong>
            </div>
            <span style="color: ${optionVersions[0].is_correct_option ? '#28a745' : '#dc3545'}; font-weight: 500; margin-left: 10px; white-space: nowrap;">(${optionVersions[0].is_correct_option ? '✓ Correct' : '✗ Incorrect'})</span>
          </div>`;
          
          // Show all language versions of this option
          optionVersions.forEach((option: any) => {
            const languageName = option.language_name || 'Unknown Language';
            
            // FIX: Only show language name if it's not "Unknown Language"
            if (languageName !== 'Unknown Language') {
              optionsHtml += `<div style="margin-left: 12px; margin-bottom: 6px;">
                <span style="font-size: 11px; color: #666; font-weight: 500;">${languageName}:</span><br>
                <span style="font-size: 15px; color: #333;">${option.option_text || 'N/A'}</span>
              </div>`;
            } else {
              // FIX: Show option text directly without language label if language is unknown
              optionsHtml += `<div style="margin-left: 12px; margin-bottom: 6px;">
                <span style="font-size: 15px; color: #333;">${option.option_text || 'N/A'}</span>
              </div>`;
            }
            
            // Format attachments for this option version
            let attachmentsHtml = '';
            if (option.attachments) {
              let attachmentUrls: string[] = [];
              
              if (Array.isArray(option.attachments)) {
                attachmentUrls = option.attachments
                  .map((att: any) => extractCleanUrl(att))
                  .filter((url: string) => url !== '');
              } else if (typeof option.attachments === 'string') {
                attachmentUrls = option.attachments
                  .split(/[,;]/)
                  .map((att: string) => extractCleanUrl(att))
                  .filter((url: string) => url !== '');
              }
              
              if (attachmentUrls.length > 0) {
                attachmentsHtml += '<div style="margin-top: 4px; margin-left: 12px;">';
                
                attachmentUrls.forEach((attachmentUrl: string) => {
                  let fullUrl = attachmentUrl;
                  if (!fullUrl.includes('http')) {
                    fullUrl = 'https://' + fullUrl;
                  }
                  
                  const fileName = attachmentUrl.split('/').pop() || 'Attachment';
                  attachmentsHtml += `<div style="margin-left: 12px; padding: 2px 0;">
                    <a href="${fullUrl}" target="_blank" style="color: #0066cc; text-decoration: none; font-size: 11px; cursor: pointer;">
                      📎 ${fileName}
                    </a>
                  </div>`;
                });
                
                attachmentsHtml += '</div>';
              }
            }
            
            optionsHtml += attachmentsHtml;
          });
          
          optionsHtml += `</div>`;
          optionIndex++;
        }
        
        result['Options'] = optionsHtml;
      } else {
        result['Options'] = 'No options available';
      }
      break;

    case 2: // True/False Question
      // Skip options if it's a practical question
      if (isPracticalQuestion && element.kpi_records && element.kpi_records.length > 0) {
        result['KPI Records'] = renderKpiTable(element.kpi_records, '#E3E3E6', 'white');
      } else if (element.question_options && element.question_options.length > 0) {
        // For True/False questions, show only the most recent version's options
        // Normalize True/False text to handle variations like "true", "True", "false", "False", etc.
        const normalizeAnswer = (text: string): string => {
          const normalized = (text || '').toLowerCase().trim();
          if (normalized === 'true' || normalized === 't') return 'true';
          if (normalized === 'false' || normalized === 'f' || normalized === 'flase') return 'false';
          return normalized;
        };
        
        // Group options by normalized answer
        const optionsByText: { [key: string]: any } = {};
        
        element.question_options.forEach((option: any) => {
          const normalizedText = normalizeAnswer(option.option_text);
          
          // Keep the option with the most recent created_datetime
          if (!optionsByText[normalizedText]) {
            optionsByText[normalizedText] = option;
          } else {
            const existingDate = new Date(optionsByText[normalizedText].created_datetime || 0);
            const newDate = new Date(option.created_datetime || 0);
            if (newDate > existingDate) {
              optionsByText[normalizedText] = option;
            }
          }
        });
        
        // Get the most recent options
        const filteredOptions = Object.values(optionsByText);
                
        const correctOption = filteredOptions.find((opt: any) => opt.is_correct_option);
        result['Correct Answer'] = correctOption ? correctOption.option_text : 'Not specified';
        result['Options'] = filteredOptions.map((option: any) => {
          // Format attachments for this option - same as Files & Metadata
          let attachmentsHtml = '';
          if (option.attachments) {
            // Handle attachments as array or string
            let attachmentUrls: string[] = [];
            
            if (Array.isArray(option.attachments)) {
              attachmentUrls = option.attachments
                .map((att: any) => extractCleanUrl(att))
                .filter((url: string) => url !== '');
            } else if (typeof option.attachments === 'string') {
              // Handle comma-separated or semicolon-separated URLs
              attachmentUrls = option.attachments
                .split(/[,;]/)
                .map((att: string) => extractCleanUrl(att))
                .filter((url: string) => url !== '');
            }
            
            if (attachmentUrls.length > 0) {
              attachmentsHtml = '<div style="margin-top: 6px; padding-top: 6px; border-top: 1px solid #eee; font-size: 12px;">';
              
              attachmentUrls.forEach((attachmentUrl: string) => {
                // Build proper full URL if needed
                let fullUrl = attachmentUrl;
                if (!fullUrl.includes('http')) {
                  fullUrl = 'https://' + fullUrl;
                }
                
                const fileName = attachmentUrl.split('/').pop() || 'Attachment';
                
                attachmentsHtml += `<a href="${fullUrl}" target="_blank" style="color: #0066cc; text-decoration: none; display: block; padding: 2px 0; cursor: pointer;">📎 ${fileName}</a>`;
              });
              
              attachmentsHtml += '</div>';
            }
          }
          
          return `${option.option_text} - ${option.is_correct_option ? 'Correct' : 'Incorrect'}${attachmentsHtml}`;
        }).join('<br>');
      } else {
        result['Correct Answer'] = 'Not specified';
      }
      break;

    case 3: // Fill In The Blanks Question
      if (element.actual_statement_text) {
        result['Statement'] = element.actual_statement_text;
      }
      if (element.blank_indices_start_end_data && Array.isArray(element.blank_indices_start_end_data)) {
        result['Blanks'] = element.blank_indices_start_end_data.map((blank: any, index: number) => {
          return `Blank ${index + 1}: "${blank.blank_text}" → Answer: "${blank.ans}"`;
        }).join('<br>');
      }
      if (element.blank_text_ans_key_data) {
        result['Answer Key'] = Object.entries(element.blank_text_ans_key_data as Record<string, string>)
          .map(([key, value]) => `[${key}]: ${value}`)
          .join('<br>');
      }
      result['Total Blanks'] = element.count_of_blanks || '0';
      break;

    case 4: // Matching Questions
      // Skip options if it's a practical question
      if (isPracticalQuestion && element.kpi_records && element.kpi_records.length > 0) {
        result['KPI Records'] = renderKpiTable(element.kpi_records, '#E3E3E6', 'black');
      } else if (element.question_options && element.question_options.length > 0) {
        // Group options by list_order_id and keep only the latest (highest ID) for each group
        const groupedOptions: { [key: string]: any } = {};
        
        element.question_options.forEach((option: any) => {
          const groupKey = `${option.is_primary_list}_${option.list_order_id}`;
          
          // Keep the option with the highest ID (latest update)
          if (!groupedOptions[groupKey] || option.id > groupedOptions[groupKey].id) {
            groupedOptions[groupKey] = option;
          }
        });

        // Convert grouped options back to array
        const latestOptions = Object.values(groupedOptions);
        
        const primaryList = latestOptions.filter((opt: any) => opt.is_primary_list);
        const secondaryList = latestOptions.filter((opt: any) => !opt.is_primary_list);

        // Create table for matching
        let tableHtml = '<div style="margin-bottom: 20px;">';

        // Primary List (Left Column)
        if (primaryList.length > 0) {
          tableHtml += '<div style="display: flex; gap: 30px; margin-bottom: 20px;">';

          tableHtml += '<div style="flex: 1;">';
          tableHtml += '<h4 style="margin: 0 0 10px 0; color: #333; font-size: 14px; font-weight: 600;">Primary List (Column A)</h4>';
          tableHtml += '<div style="border: 1px solid #ddd; border-radius: 4px; overflow: hidden;">';

          primaryList.forEach((opt: any) => {
            const listValues = opt.list_values || {};
            const listOrder = opt.list_order_id || 1;

            tableHtml += `<div style="padding: 8px 12px; border-bottom: 1px solid #eee; background-color: #f8f9fa;">
              <strong style="color: #495057;">List ${listOrder}:</strong>`;

            Object.entries(listValues as Record<string, string>).forEach(([key, value]) => {
              tableHtml += `<div style="padding: 4px 0 4px 20px;">
                <span style="color: #666; margin-right: 8px;">${key}.</span>
                <span>${value}</span>
              </div>`;
              const attachmentHtml = renderListValueAttachmentsForKey(opt.list_value_attachments, key);
              if (attachmentHtml) {
                tableHtml += attachmentHtml;
              }
            });

            tableHtml += '</div>';
          });

          tableHtml += '</div></div>';

          // Secondary List (Right Column)
          if (secondaryList.length > 0) {
            tableHtml += '<div style="flex: 1;">';
            tableHtml += '<h4 style="margin: 0 0 10px 0; color: #333; font-size: 14px; font-weight: 600;">Secondary List (Column B)</h4>';
            tableHtml += '<div style="border: 1px solid #ddd; border-radius: 4px; overflow: hidden;">';

            secondaryList.forEach((opt: any) => {
              const listValues = opt.list_values || {};
              const listOrder = opt.list_order_id || 2;

              tableHtml += `<div style="padding: 8px 12px; border-bottom: 1px solid #eee; background-color: #f8f9fa;">
                <strong style="color: #495057;">List ${listOrder}:</strong>`;

              Object.entries(listValues as Record<string, string>).forEach(([key, value]) => {
                tableHtml += `<div style="padding: 4px 0 4px 20px;">
                  <span style="color: #666; margin-right: 8px;">${key}.</span>
                  <span>${value}</span>
                </div>`;
                 const attachmentHtml = renderListValueAttachmentsForKey(opt.list_value_attachments, key);
                if (attachmentHtml) {
                  tableHtml += attachmentHtml;
                }
              });

              tableHtml += '</div>';
            });

            tableHtml += '</div></div>';
          }

          tableHtml += '</div>';

          // Correct Matching Sequence
          if (secondaryList.length > 0) {
            let hasCorrectSequence = false;
            secondaryList.forEach((opt: any) => {
            if (!this.baseCorrectSequence && opt.list_correct_sequence) {
              this.baseCorrectSequence = opt.list_correct_sequence;
            }

              const correctSequence = this.baseCorrectSequence || {};   
              if (Object.keys(correctSequence).length > 0) {
                hasCorrectSequence = true;
              }
            });

            if (hasCorrectSequence) {
              tableHtml += '<h4 style="margin: 20px 0 10px 0; color: #333; font-size: 14px; font-weight: 600;">Correct Matching Sequence</h4>';
              tableHtml += '<div style="background-color: #f8f9fa; border: 1px solid #e9ecef; border-radius: 4px; padding: 12px;">';

              secondaryList.forEach((opt: any, idx: number) => {

                if (!this.baseCorrectSequence && opt.list_correct_sequence) {
                  this.baseCorrectSequence = opt.list_correct_sequence;
                }
                const correctSequence = this.baseCorrectSequence || {};
                const listValues = opt.list_values || {};

                if (Object.keys(correctSequence).length > 0) {
                  tableHtml += `<div style="margin-bottom: ${idx < secondaryList.length - 1 ? '12px' : '0'};">`;
                  tableHtml += `<strong style="color: #495057; font-size: 13px;">List ${opt.list_order_id || 2} Matches:</strong>`;
                  tableHtml += '<div style="margin-top: 6px;">';

                  const entries = Object.entries(correctSequence as Record<string, string>);
                  entries.sort((a, b) => parseInt(a[1], 10) - parseInt(b[1], 10));
                  entries.forEach(([secKey, priKey]) => {
                    const primaryKey = priKey;
                    const secondaryKey = secKey;
                    
                    const primaryValue = this.getPrimaryValue(primaryList, primaryKey);
                    const secondaryValue = (listValues as Record<string, string>)[secondaryKey] || `Item ${secondaryKey}`;

                    tableHtml += `<div style="padding: 6px 10px; margin-bottom: 4px; background-color: white; border-radius: 3px; border-left: 3px solid #28a745;">
                      <span style="color: #666;">${primaryKey}.</span>
                      <span style="color: #333; margin: 0 10px;">${primaryValue}</span>
                      <span style="color: #666;">→</span>
                      <span style="color: #333; margin: 0 10px 0 20px;">${secondaryKey}.</span>
                      <span style="color: #333;">${secondaryValue}</span>
                    </div>`;
                  });

                  tableHtml += '</div></div>';
                }
              });

              tableHtml += '</div>';
            }
          }
        }

        tableHtml += '</div>';
        result['Matching Table'] = tableHtml;
      }
      break;

    case 5: // Subjective Answer Question
    case 6: // Scenario Based Question
      if (element.subjective_answer_id) {
        result['Sample Answer'] = element.sample_answer_for_reference || 'Not provided';
        result['Answer Keywords'] = element.answer_keywords || 'Not provided';
        result['Evaluation Remarks'] = element.evaluation_remarks || 'Not provided';
      }
      break;

    case 7: // Multi-select Question
      // Skip options if it's a practical question
      if (isPracticalQuestion && element.kpi_records && element.kpi_records.length > 0) {
        result['KPI Records'] = renderKpiTable(element.kpi_records, '#E3E3E6', 'black');
      } else if (element.question_options && element.question_options.length > 0) {
        // Filter options by language ID - keep only options for the current language
        // Get current language ID from element (this is the primary question we're displaying)
        const currentLanguageId = element.language_id;
        
        // Group options by language to filter correctly
        const optionsByLanguage: { [key: number]: any[] } = {};
        
        element.question_options.forEach((option: any) => {
          const langId = option.language_id || element.language_id || 1;
          if (!optionsByLanguage[langId]) {
            optionsByLanguage[langId] = [];
          }
          optionsByLanguage[langId].push(option);
        });
        
        // Get options for current language
        let filteredOptions = optionsByLanguage[currentLanguageId] || [];
        
        // If no options for current language, use the first available language's options
        if (filteredOptions.length === 0) {
          const availableLanguages = Object.keys(optionsByLanguage).map(Number);
          if (availableLanguages.length > 0) {
            filteredOptions = optionsByLanguage[availableLanguages[0]] || [];
            console.log(`[Multi-Select Q${element.question_id}] No options for Language ${currentLanguageId}, using Language ${availableLanguages[0]}`);
          }
        }
        filteredOptions = dedupeOptionsByOrder(filteredOptions);
        const correctOptions = filteredOptions.filter((opt: any) => opt.is_correct_option);
        result['Correct Options'] = correctOptions.map((opt: any) => opt.option_text).join(', ');
        
        // Format options with consistent design matching Multiple Choice questions
        const sortedOptions = getSortedOptions(filteredOptions);
        let optionsHtml = '';
        let optionIndex = 1;
        sortedOptions.forEach((option: any) => {
          const isCorrect = Boolean(option.is_correct_option);
          const borderColor = isCorrect ? '#28a745' : '#dc3545';
          const badgeColor = isCorrect ? '#28a745' : '#dc3545';
          const badge = isCorrect ? '✓ Correct' : '✗ Incorrect';
          
          // Format attachments for this option
          let attachmentsHtml = '';
          if (option.attachments) {
            let attachmentUrls: string[] = [];
            
            if (Array.isArray(option.attachments)) {
              attachmentUrls = option.attachments
                .map((att: any) => extractCleanUrl(att))
                .filter((url: string) => url !== '');
            } else if (typeof option.attachments === 'string') {
              attachmentUrls = option.attachments
                .split(/[,;]/)
                .map((att: string) => extractCleanUrl(att))
                .filter((url: string) => url !== '');
            }
            
            if (attachmentUrls.length > 0) {
              attachmentsHtml = '<div style="margin-top: 8px; padding-top: 8px; border-top: 1px solid #eee; font-size: 12px;">';
              
              attachmentUrls.forEach((attachmentUrl: string) => {
                let fullUrl = attachmentUrl;
                if (!fullUrl.includes('http')) {
                  fullUrl = 'https://' + fullUrl;
                }
                
                const fileName = attachmentUrl.split('/').pop() || 'Attachment';
                
                attachmentsHtml += `<a href="${fullUrl}" target="_blank" style="color: #0066cc; text-decoration: none; display: block; padding: 2px 0; cursor: pointer;">📎 ${fileName}</a>`;
              });
              
              attachmentsHtml += '</div>';
            }
          }
          
          // Build option HTML with consistent styling
          optionsHtml += `<div style="margin-bottom: 12px; padding: 12px; border-left: 3px solid ${borderColor}; border-radius: 2px;">
            <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 8px;">
              <div>
                <strong>Option ${optionIndex}:</strong>
              </div>
              <span style="color: ${badgeColor}; font-weight: 500; margin-left: 10px; white-space: nowrap;">(${badge})</span>
            </div>
            <div style="margin-left: 12px;">
              <span style="font-size: 15px; color: #333;">${option.option_text || 'N/A'}</span>
            </div>
            ${attachmentsHtml}
          </div>`;
          
          optionIndex++;
        });
        
        result['All Options'] = optionsHtml;
      }
      break;

    case 8: // Activity - Performance Task
    case 9: // Activity - Audio/Video Response
    case 10: // Activity - Real-time Video Streaming Based Viva
    case 11: // Activity - File Submission
      // For practical/activity questions, show KPI records
      if (element.kpi_records && element.kpi_records.length > 0) {
        const sortedKpis = [...element.kpi_records].sort(sortById);
        result['KPI Records'] = renderKpiTable(sortedKpis, '#E3E3E6', 'black');
      } else if (element.question_options && element.question_options.length > 0) {
        // Fallback to question_options if kpi_records not available
        result['KPI Details'] = renderKpiTable(element.question_options, '#E3E3E6', 'black');
      }
      break;

    default:
      // For other question types, show generic options
      if (element.question_options && element.question_options.length > 0) {
        result['Options'] = element.question_options.map((option: any, index: number) => {
          let optionText = '';
          if (option.option_text) {
            optionText = `Option: ${option.option_text}`;
          }
          if (option.is_correct_option !== undefined) {
            optionText += ` - ${option.is_correct_option ? 'Correct' : 'Incorrect'}`;
          }
          return optionText || `Option ${index + 1}`;
        }).filter(Boolean).join('<br>');
      }
      break;
  }

  return result;
}

// Helper method to get primary list value
getPrimaryValue(primaryList: any[], key: string): string {
  for (const primary of primaryList) {
    const listValues = primary.list_values as Record<string, string> || {};
    if (listValues[key]) {
      return listValues[key];
    }
  }
  return `Item ${key}`;
}
  applyFilter(event: any, type?: string) {
    let filterValue;
    if (type) {
      filterValue = event;
    } else {
      filterValue = (event.target as HTMLInputElement).value;
    }
    this.searchedString = filterValue.trim();
    if (this.moduleType === 'questions' || this.pageType === 'question banks' || this.serverSidePagination) {
      this.allTextSearch.emit(this.searchedString);
      return;
    }

    this.tableDataSource.filter = filterValue.trim().toLowerCase();
  }
  onAllTextPaste(event: ClipboardEvent) {
    event.preventDefault();
    const pasted = (event.clipboardData && event.clipboardData.getData)
      ? event.clipboardData.getData('text')
      : (window && (window as any).clipboardData ? (window as any).clipboardData.getData('Text') : '');

    // Update the ngModel value and trigger the same filter flow
    this.allTextFilterValue = pasted;
    // Call applyFilter with pasted string so the component emits to parent
    this.applyFilter(pasted, 'all');
  }

  sortTable(sortParameters: Sort) {
    console.log(this.tableColumns.find((column) => column.name === sortParameters.active).dataKey, 'sort params', sortParameters);
    sortParameters.active = this.tableColumns.find((column) => column.name === sortParameters.active).dataKey;
    this.sort.emit(sortParameters);
    const sortedData = this.sortData(sortParameters);
    this.setTableDataSource(sortedData);
  }

  emitRowAction(rowName: any, row: any) {
    this.rowAction.emit({ rowName: rowName, row: row });
  }

  emitActionTag(tag: any) {
    this.tableActionTag.emit({ tag });
  }

  
  isAttachmentColumn(tableColumn: TableColumn): boolean {
    return (
      tableColumn?.dataKey === 'attachmentsDisplay' &&
      this.moduleType === 'finance' &&
      this.pageType === 'bills'
    );
  }

  
  openAttachmentPreview(element: any, tableColumn: TableColumn) {
    const displayValue = element?.[tableColumn.dataKey];
    const firstName = Array.isArray(displayValue)
      ? displayValue[0]
      : (typeof displayValue === 'string' ? displayValue.split(',')[0].trim() : displayValue);

    const rawAttachments = element?._rawAttachments;
    const rawMatch = Array.isArray(rawAttachments)
      ? rawAttachments.find((att: any) => (att?.name || '') === firstName)
      : null;

    const mappedUrl = element?._attachmentUrlMap?.[firstName];

    const resolved = rawMatch?.url || rawMatch?.key || mappedUrl || firstName;
    this.emitActionTag(resolved);
  }

  convertDate() {
    var day;
    var month;
    var date = new Date();
    day = date.getDate();
    month = date.getMonth();
    month = month + 1;
    if (String(day).length == 1) day = '0' + day;
    if (String(month).length == 1) month = '0' + month;
    return date.getFullYear() + '' + month + '' + day;
  }

  private getExportFileNamePrefix(): string {
    const explicitTitle = this.tableTitle?.toString().trim();
    if (explicitTitle) {
      return explicitTitle.replace(/\s+/g, '_').replace(/[^a-zA-Z0-9._-]+/g, '_').replace(/^_+|_+$/g, '');
    }

    const fallbackName = (this.pageType || this.moduleType || 'data').toString().trim().toLowerCase();
    const singularMap: Record<string, string> = {
      accounts: 'account',
      account: 'account',
      leads: 'lead',
      lead: 'lead',
      bills: 'bill',
      bill: 'bill',
      invoices: 'invoice',
      invoice: 'invoice',
    };

    const normalizedName = singularMap[fallbackName] || fallbackName;
    return normalizedName.replace(/\s+/g, '_').replace(/[^a-zA-Z0-9._-]+/g, '_').replace(/^_+|_+$/g, '') || 'data';
  }

  private buildExportFileName(): string {
    return `${this.getExportFileNamePrefix()}_${this.convertDate()}_${new Date().getTime()}`;
  }

  sortData(sortParameters: Sort) {
    const keyName = sortParameters.active;
    const { direction } = sortParameters;

    if (!direction) return this.originalTableData;

    const isAsc = direction === 'asc';
    const isQuestionTable = this.moduleType === 'questions' || this.pageType === 'question banks';

    const sortedData = [...this.originalTableData].sort((a: any, b: any) => {
      const valueA = a[keyName];
      const valueB = b[keyName];

      const isDateA = typeof valueA === 'string' && !isNaN(Date.parse(valueA));
      const isDateB = typeof valueB === 'string' && !isNaN(Date.parse(valueB));

      // Date sorting
      if (isDateA && isDateB) {
        const timeA = new Date(valueA).getTime();
        const timeB = new Date(valueB).getTime();
        return isAsc ? timeA - timeB : timeB - timeA;
      }

      // Number sorting
      if (typeof valueA === 'number' && typeof valueB === 'number') {
        return isAsc ? valueA - valueB : valueB - valueA;
      }

      // String sorting
      if (typeof valueA === 'string' && typeof valueB === 'string') {
        return isAsc
          ? valueA.localeCompare(valueB)
          : valueB.localeCompare(valueA);
      }

      return 0;
    });

    if (isQuestionTable) {
      const startIndex =
        (this.matPaginator?.pageIndex || 0) *
        (this.matPaginator?.pageSize || this.defaultPageSize);

      return sortedData.map((row, index) => ({
        ...row,
        sno: startIndex + index + 1
      }));
    }

    return sortedData.map((row, index) => ({
      ...row,
      sno: index + 1
    }));
  }

  toogleEmitterClick(event: any, row: any, column?: any) {
    if (this.handleToggleInParent) {
      this.toogleEmitter.emit({
        checked: event.checked,
        id: row?.id,
        row: row,
        column: column?.dataKey || null
      });
    } else {
      if (row?.id) {
        try {
          this.updateStatusService.updateStatus(event, row?.id);
        } catch {
          this.toogleEmitter.emit({
            checked: event.checked,
            id: row?.id,
            row: row,
          });
        }
      } else {
        try {
          this.updateStatusService.updateStatus(event, row);
        } catch {
          this.toogleEmitter.emit({
            checked: event.checked,
            row: row
          });
        }
      }
    }
  }

 onClickCheckboxItem(event, row) {
  if (this.moduleType === 'questions' || this.pageType === 'question banks') {
    const rowKey = this.getRowKey(row);
    if (rowKey === null) return;
    const selectedItems = Array.isArray(this.selectedItems) ? [...this.selectedItems] : [];
    const existingIndex = selectedItems.findIndex(item => this.getRowKey(item) === rowKey);
    const isSelected = existingIndex > -1;
    if (!isSelected) {
      selectedItems.push(row);
      this.selection.select(row);
    } else {
      selectedItems.splice(existingIndex, 1);
      this.selection.deselect(row);
    }
    this._selectedItems = selectedItems;

    this.restoreSelectionForCurrentPage();
    this.selectedItemsChange.emit(this.selectedItems);
  } else {
    const selectedItems = Array.isArray(this.selectedItems) ? [...this.selectedItems] : [];
      const selectedRow = this.selection.selected.find(item => item.id === row.id);
      const selected = !!selectedRow;
      if (!selected) {
        selectedItems.push(row);
        this.selection.select(row);
      } else {
        const index = selectedItems.findIndex((item: any) => item.id === row.id);
        if (index > -1) {
          selectedItems.splice(index, 1);
        }
        this.selection.deselect(selectedRow);
      }
    this.selectedItemsChange.emit(selectedItems)
  }
}
  private getExportRows(): any[] {
    const selectedRows = Array.isArray(this.selection?.selected) ? this.selection.selected : [];
    const totalRows = this.originalTableData?.length || 0;

    if (selectedRows.length > 0 && selectedRows.length < totalRows) {
      return selectedRows;
    }

    const filteredRows = this.tableDataSource?.filteredData;
    if (Array.isArray(filteredRows) && filteredRows.length > 0) {
      return filteredRows;
    }

    return Array.isArray(this.originalTableData) ? this.originalTableData : [];
  }

  tableActionsEmit(event: any) {
    if (event == 'inlineDownload') {
      const exportFileName = this.buildExportFileName();
      const exportRows = this.getExportRows();

      setTimeout(() => {
        this.exportService.exportExcel(exportRows, exportFileName);
      }, 0);
      return;
    }

    if (event == 'sampleFileDownload') {
      const type = this.tableActions.find((item) => item.name === event)?.sampleOf;
      if (type) {
        this.downloadService.downloadSampleFile(type).subscribe((data: any) => {
          let binaryData = [];
          binaryData.push(data.body);
          let downloadLink = document.createElement('a');
          downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: 'blob' }));
          downloadLink.setAttribute(
            'download',
            `${this.getExportFileNamePrefix() || type}_sample.xlsx`
          );
          document.body.appendChild(downloadLink);
          downloadLink.click();
        });
      }
    } else {
      this.tableActionEmitter.emit(event);
    }
  }

  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ['data'],
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'buffer',
    });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
  }

  currentModalVersionNo: string = '';
  isVersionNoColumn: boolean = false;

  showAllTags(elements: any, element?: any, tableColumn?: any) {
    this.allTags = elements;
    this.type = TAGS;
    this.isVersionNoColumn = tableColumn?.dataKey === 'version_no_display' || tableColumn?.name === 'Version No';
    this.currentModalVersionNo = element?.version_no != null ? String(element.version_no) : (element?.version_id != null ? String(element.version_id) : '');
    $('#viewAllTagsPopup').modal('show');
  }

  isCurrentVersionTag(tag: any, rowElement?: any, isInModal: boolean = false): boolean {
    if (!isInModal && rowElement) {
      const isRevisionHistoryRow = rowElement.is_version_revision_history_row || 
        (typeof window !== 'undefined' && window.location && window.location.href.includes('/All'));
        
      const isCurrRow = rowElement.is_current === true || rowElement.is_current === 1 || rowElement.is_current === 'true' || rowElement.is_current === '1';

      if (isRevisionHistoryRow && isCurrRow) {
        return true;
      }
    }
    return false;
  }

  showAllAttributes(elements: any, columnName?: string) {
    this.allTags = elements;
    this.type = columnName || ATTRIBUTES;

    $(this.viewAllTagsModal.nativeElement).modal('show');
  }

  showAllStakeholders(groups: any) {
    this.allTags = groups;
    this.type = 'stakeholder_name';

    $(this.viewAllTagsModal.nativeElement).modal('show');
  }

  getQpvLabelNames(labelData: any): string[] {
    if (!labelData) return [];
    const names: string[] = [];
    const items = Array.isArray(labelData) ? labelData : [labelData];
    items.forEach((item: any) => {
      if (item && Array.isArray(item.labels)) {
        item.labels.forEach((label: any) => {
          const name = label.labelName || label.label_name || '';
          if (name && !names.includes(name)) {
            names.push(name);
          }
        });
      } else if (item && typeof item === 'object') {
        const name = item.labelName || item.label_name || '';
        if (name && !names.includes(name)) {
          names.push(name);
        }
      }
    });
    return names;
  }

  showQpvLabelsPopup(element: any) {
    if (element.label) {
      const labelData = Array.isArray(element.label) ? element.label : [element.label];
      const allRootsMap = new Map<string, any>();

      // Process each group wrapper independently
      labelData.forEach((group: any) => {
        if (!group || !Array.isArray(group.labels)) return;
        
        // Extract valid nodes from this group
        const groupNodes = group.labels.filter((item: any) => {
          const labelName = item.labelName || item.label_name || item.name;
          return labelName && String(labelName).trim() !== '';
        }).map((item: any) => ({
          ...item,
          labelName: item.labelName || item.label_name || item.name || '',
          children: [],
          collapsed: false
        }));

        // Build hierarchy for THIS GROUP only, avoiding ID collisions with other groups
        const labelIdMap = new Map<string, any>();
        groupNodes.forEach((node: any) => {
          const primaryId = node.labelId !== undefined && node.labelId !== null ? node.labelId : 
                           (node.id !== undefined && node.id !== null ? node.id : node.label_id);
          if (primaryId !== undefined && primaryId !== null) {
            labelIdMap.set(String(primaryId), node);
          }
        });

        const groupRoots: any[] = [];
        groupNodes.forEach((node: any) => {
          const parentId = node.parentLabelId !== undefined && node.parentLabelId !== null ? node.parentLabelId : node.parent_label_id;
          
          if (parentId && parentId !== 0 && labelIdMap.has(String(parentId))) {
            const parentNode = labelIdMap.get(String(parentId));
            if (parentNode !== node) {
              parentNode.children.push(node);
            } else {
              groupRoots.push(node);
            }
          } else {
            groupRoots.push(node);
          }
        });

        // Add this group's roots to the global roots map, deduplicating by unique node ID
        groupRoots.forEach((rootNode: any) => {
          const uniqueId = rootNode.id;
          if (uniqueId !== undefined && uniqueId !== null) {
            if (!allRootsMap.has(String(uniqueId))) {
              allRootsMap.set(String(uniqueId), rootNode);
            }
          } else {
            // Fallback for nodes with no mapping ID
            allRootsMap.set(Math.random().toString(), rootNode); 
          }
        });
      });

      const rawRoots = Array.from(allRootsMap.values());
      const allChildrenIds = new Set<string>();

      // Recursively find all children IDs
      const collectChildrenIds = (nodes: any[]) => {
        nodes.forEach(node => {
          if (node.children && node.children.length > 0) {
            node.children.forEach((child: any) => {
              if (child.id !== undefined && child.id !== null) {
                allChildrenIds.add(String(child.id));
              }
            });
            collectChildrenIds(node.children);
          }
        });
      };
      
      collectChildrenIds(rawRoots);

      // Filter out any root that exists as a child somewhere else
      this.labelHierarchy = rawRoots.filter(root => {
        if (root.id !== undefined && root.id !== null) {
          return !allChildrenIds.has(String(root.id));
        }
        return true;
      });

      this.calculateLevels(this.labelHierarchy, 0);
    } else {
      this.labelHierarchy = [];
    }
    
    this.type = 'qpv_labels';
    $(this.viewAllTagsModal.nativeElement).modal('show');
  }

  buildLabelHierarchy(labels: any[]): any[] {
    if (!labels || !Array.isArray(labels)) return [];
    
    // Step 1: Create a wrapper node for every item in the input array
    const nodes: any[] = labels.map((label) => ({
      ...label,
      labelName: label.labelName || label.label_name || label.name || '',
      children: [],
      collapsed: false
    }));

    // Step 2: Map each primary identifier to its node(s)
    const labelIdMap = new Map<number | string, any[]>();
    nodes.forEach((node) => {
      const primaryId = node.labelId !== undefined && node.labelId !== null
        ? node.labelId
        : (node.id !== undefined && node.id !== null ? node.id : node.label_id);
      
      if (primaryId !== undefined && primaryId !== null) {
        const key = typeof primaryId === 'number' ? primaryId : String(primaryId);
        if (!labelIdMap.has(key)) {
          labelIdMap.set(key, []);
        }
        labelIdMap.get(key).push(node);
      }
    });

    // Step 3: Link children to parents and collect roots
    const roots: any[] = [];
    nodes.forEach((node) => {
      const parentId = node.parentLabelId !== undefined && node.parentLabelId !== null
        ? node.parentLabelId
        : node.parent_label_id;

      let attachedToParent = false;
      if (parentId && parentId !== 0) {
        const parentKey = typeof parentId === 'number' ? parentId : String(parentId);
        const parentNodes = labelIdMap.get(parentKey);
        
        if (parentNodes && parentNodes.length > 0) {
          // Attach to parent node (avoiding self-reference)
          const parentNode = parentNodes.find(p => p !== node) || parentNodes[0];
          if (parentNode && parentNode !== node) {
            parentNode.children.push(node);
            attachedToParent = true;
          }
        }
      }

      if (!attachedToParent) {
        roots.push(node);
      }
    });

    return roots;
  }

  calculateLevels(nodes: any[], currentLevel: number = 0) {
    nodes.forEach(node => {
      node.level = currentLevel;
      if (node.children && node.children.length > 0) {
        this.calculateLevels(node.children, currentLevel + 1);
      }
    });
  }

  toggleNode(node: any) {
    node.collapsed = !node.collapsed;
  }

  closeViewAllTagsModal() {
    $(this.viewAllTagsModal.nativeElement).modal('hide');
  }

  radioButtonHandler(row) {
    if (this.radioButtonCallBack) this.radioButtonCallBack(row);
  }

  filters() {
    let filteredData = [...this.originalTableData];

    const selectedFilters = this.selectedFilters?.filters || {};
    console.log('selectedFilters', selectedFilters);

    // Apply all active filters dynamically
    filteredData = filteredData.filter(element => {
      return Object.values(selectedFilters).every((filter: any) => {
        const type = filter.type;
        const key = filter.datakey || type;

        console.log('Filtering element:', element, 'with filter:', filter);

        switch (type) {
          case 'tat_days': {
            const filterOperator = filter.operator || 'equals';

            let elementTatDays = 0;
            if (Array.isArray(element.tat_analysis) && element.tat_analysis.length > 0) {
              const tatItem = element.tat_analysis[0];
              if (tatItem._originalDetails) {
                elementTatDays = tatItem._originalDetails.overall_tat_days || 0;
              }
              else if (tatItem.overall_tat_days !== undefined) {
                elementTatDays = tatItem.overall_tat_days;
              }
              else if (tatItem.value) {
                const match = tatItem.value.match(/(\d+)\s*days/);
                if (match) {
                  elementTatDays = parseInt(match[1]);
                }
              }
            }
            else if (element.tat_analysis && typeof element.tat_analysis === 'object') {
              elementTatDays = element.tat_analysis.overall_tat_days || 0;
            }
            const filterValue = parseFloat(filter.value || 0);
            const filterStart = parseFloat(filter.start || 0);
            const filterEnd = parseFloat(filter.end || 0);

            console.log(`   Filter - Operator: ${filterOperator}, Value: ${filterValue}`);

            let result = false;

            switch (filterOperator) {
              case 'equals':
                result = elementTatDays === filterValue;
                break;
              case 'greater_than':
                result = elementTatDays > filterValue;
                break;
              case 'less_than':
                result = elementTatDays < filterValue;
                break;
              case 'greater_than_equal':
                result = elementTatDays >= filterValue;
                break;
              case 'less_than_equal':
                result = elementTatDays <= filterValue;
                break;
              case 'between':
                result = elementTatDays >= filterStart && elementTatDays <= filterEnd;
                break;
              default:
                result = true;
            }

            return result;
          }
          case 'pass_percentage': {
            const filterOperator = filter.operator || 'equals';

            let elementPassPercentage = 0;
            if (element.pass_analysis && typeof element.pass_analysis === 'object') {
              elementPassPercentage = element.pass_analysis.pass_percentage || 0;
            } else if (Array.isArray(element.pass_analysis) && element.pass_analysis.length > 0) {
              const passAnalysis = element.pass_analysis[0]._originalDetails || element.pass_analysis[0];
              elementPassPercentage = passAnalysis.pass_percentage || 0;
            } else if (element.pass_percentage !== undefined && element.pass_percentage !== null) {
              elementPassPercentage = parseFloat(element.pass_percentage) || 0;
            }

            let result = false;

            switch (filterOperator) {
              case 'equals':
                result = elementPassPercentage === parseFloat(filter.value || 0);
                break;
              case 'greater_than':
                result = elementPassPercentage > parseFloat(filter.value || 0);
                break;
              case 'less_than':
                result = elementPassPercentage < parseFloat(filter.value || 0);
                break;
              case 'greater_than_equal':
                result = elementPassPercentage >= parseFloat(filter.value || 0);
                break;
              case 'less_than_equal':
                result = elementPassPercentage <= parseFloat(filter.value || 0);
                break;
              case 'between':
                const start = parseFloat(filter.start || 0);
                const end = parseFloat(filter.end || 0);
                result = elementPassPercentage >= start && elementPassPercentage <= end;
                break;
              default:
                result = true;
            }

            return result;
          }
          // ---------------- IMPRESSION COUNT ----------------
          case constants.IMPRESSION_COUNT: {
            const filterOperator = filter.operator || 'equals';
            const elementValue = parseFloat(element[key]) || 0;
            let result = false;

            console.log('Impression Count Filter:', {
              operator: filterOperator,
              filterValue: filter.value,
              filterStart: filter.start,
              filterEnd: filter.end,
              elementValue: elementValue
            });

            switch (filterOperator) {
              case 'equals':
                result = elementValue === parseFloat(filter.value || 0);
                break;
              case 'greater_than':
                result = elementValue > parseFloat(filter.value || 0);
                break;
              case 'less_than':
                result = elementValue < parseFloat(filter.value || 0);
                break;
              case 'greater_than_equal':
                result = elementValue >= parseFloat(filter.value || 0);
                break;
              case 'less_than_equal':
                result = elementValue <= parseFloat(filter.value || 0);
                break;
              case 'between':
                const start = parseFloat(filter.start || 0);
                const end = parseFloat(filter.end || 0);
                result = elementValue >= start && elementValue <= end;
                break;
              default:
                result = true;
            }

            console.log('Impression Count Filter Result:', result);
            return result;
          }

          // ---------------- STATUS ----------------
          case constants.STATUS:
            const selectedStatuses = filter.value || [];
            console.log('selectedStatus', selectedStatuses);
            if (selectedStatuses.length === 0) return true;

            // Check if element matches any selected status
            return selectedStatuses.some(label => {
              switch (label.toLowerCase()) {
                case 'archived': return element.is_archived;
                case 'unarchived': return !element.is_archived;
                case 'active': return element.is_active;
                case 'inactive': return !element.is_active;
                case 'deleted': return element.is_deleted;
                default:
                  return element.status?.toLowerCase() === label.toLowerCase();
              }
            });

          // ---------------- STATIC ----------------
          case constants.STATIC:
            const selectedStaticValues = (filter.value || [])
              .filter(v => v != null)
              .map(v => v.toString().toLowerCase());

            if (selectedStaticValues.length === 0) return true;

            const staticValue = element[key];

            if (Array.isArray(staticValue)) {
              return staticValue.some(v =>
                v != null &&
                selectedStaticValues.includes(v.toString().toLowerCase())
              );
            }

            if (staticValue == null) return false;

            return selectedStaticValues.includes(staticValue.toString().toLowerCase());

          // ---------------- AMOUNT ----------------
          case constants.AMOUNT: {
            const filterOperator = filter.operator || 'equals';
            const elementValue = parseFloat(element[key]) || 0;
            let result = false;
            switch (filterOperator) {
              case 'equals':
                result = elementValue === parseFloat(filter.value || 0);
                break;
              case 'greater_than':
                result = elementValue > parseFloat(filter.value || 0);
                break;
              case 'less_than':
                result = elementValue < parseFloat(filter.value || 0);
                break;
              case 'greater_than_equal':
                result = elementValue >= parseFloat(filter.value || 0);
                break;
              case 'less_than_equal':
                result = elementValue <= parseFloat(filter.value || 0);
                break;
              case 'between':
                const start = parseFloat(filter.start || 0);
                const end = parseFloat(filter.end || 0);
                result = elementValue >= start && elementValue <= end;
                break;
              default:
                result = true;
            }
            return result;
          }

          // ---------------- LIST ----------------
          case constants.LIST: {
            const selectedTagFilters = filter.value || [];
            if (!selectedTagFilters.length) return true;

            const tagsList = (Array.isArray(element[key]) && element[key].length)
              ? element[key]
              : (Array.isArray(element.formattedTags) ? element.formattedTags : []);
            if (!tagsList.length) return false;

            return selectedTagFilters.some((criteria: any) => {
              let critKey = '';
              let critVal = '';

              if (typeof criteria === 'object' && criteria !== null) {
                critKey = (criteria.key || '').toString().trim().toLowerCase();
                critVal = (criteria.value || '').toString().trim().toLowerCase();
              } else if (typeof criteria === 'string') {
                const parts = criteria.split(':');
                if (parts.length >= 2) {
                  critKey = parts[0].trim().toLowerCase();
                  critVal = parts.slice(1).join(':').trim().toLowerCase();
                } else {
                  critVal = criteria.trim().toLowerCase();
                }
              }

              if (!critVal && !critKey) return true;

              return tagsList.some(tag => {
                const { key: tagKey, value: tagVal } = this.getTagKeyValue(tag);

                if (critKey && tagKey) {
                  const keyMatch = tagKey === critKey || tagKey.includes(critKey) || critKey.includes(tagKey);
                  const valMatch = !critVal || tagVal.includes(critVal) || critVal.includes(tagVal);
                  return keyMatch && valMatch;
                }

                if (critKey && !tagKey) {
                  return tagVal.includes(critKey) || (critVal ? tagVal.includes(critVal) : false);
                }

                if (!critKey && critVal) {
                  return tagVal.includes(critVal) || tagKey.includes(critVal);
                }

                return true;
              });
            });
          }

          case constants.TEXT:
            const searchText = filter.option === 'is' ? (filter.isValue || '') : filter.option === 'contains' ? (filter.containsValue || '') : (filter.isValue || filter.containsValue || '');
            if (!searchText) return true;

            let elementValue = '';

            const value = element[key];

            if (filter.type === 'tags' || key === 'tags') {
              const tags = (Array.isArray(value) && value.length)
                ? value
                : (Array.isArray(element.formattedTags) ? element.formattedTags : []);

              if (!tags.length) return false;

              const searchLower = searchText.trim().toLowerCase();

              return tags.some(tag => {
                const { key: tagKey, value: tagVal } = this.getTagKeyValue(tag);
                const fullText = (tagKey ? `${tagKey}:${tagVal}` : tagVal).toLowerCase();

                if (filter.option === constants.IS) {
                  return tagVal === searchLower || fullText === searchLower || tagKey === searchLower;
                } else {
                  return tagVal.includes(searchLower) || tagKey.includes(searchLower) || fullText.includes(searchLower);
                }
              });
            } else if (value && typeof value === 'object') {

    elementValue = Object.values(value)
      .map(v => (v !== null && v !== undefined ? v.toString() : ''))
      .join(' ')
      .trim()
      .replace(/\s+/g, ' ')
      .toLowerCase();

  } else {

    elementValue = (value || '')
      .toString()
      .trim()
      .replace(/\s+/g, ' ')
      .toLowerCase();

  }

  const searchValue = (searchText || '')
    .toString()
    .trim()
    .replace(/\s+/g, ' ')
    .toLowerCase();

  if (filter.option === constants.IS)
    return elementValue === searchValue;

  if (filter.option === constants.CONTAINS)
    return elementValue.includes(searchValue);

  return true;
          case constants.NUMBER:
            if (filter.isValue === undefined || filter.isValue === null) return true;
            return parseFloat(element[key] || 0) === parseFloat(filter.isValue);

          case constants.DATE:
            if (!filter.start) return true;
            const elementDate = moment(element[key]);
            if (filter.option === constants.IS) return elementDate.isSame(moment(filter.start), 'day');
            if (filter.option === constants.BETWEEN && filter.end)
              return elementDate.isBetween(moment(filter.start), moment(filter.end), 'day', '[]');
            return true;

          case constants.ALL:
            if (!filter.value) return true;
            return JSON.stringify(element).toLowerCase().includes(filter.value.toLowerCase());

          default:
            return true;
        }
      });
    });

    // Update table
    console.log('Filtered data count:', filteredData.length);
    this.tableDataSource.data = filteredData;

    if (this.matPaginator) {
      this.matPaginator.firstPage();
    }
  }


  //   filters() {
  //     let filteredData = [...this.originalTableData];

  //     // Apply date filter if exists
  //     if (this.selectedFilters.filters[constants.DATE]) {
  //       filteredData = this.dateRangeChange(filteredData);
  //     }

  //     // Apply other filters
  //     filteredData = this.onFilterSelect(filteredData);

  //     // Apply All Text search if exists
  //     if (this.selectedFilters.filters[constants.ALL]?.value) {
  //       const searchValue = this.selectedFilters.filters[constants.ALL].value.toLowerCase();
  //       filteredData = filteredData.filter(item =>
  //         JSON.stringify(item).toLowerCase().includes(searchValue)
  //       );
  //     }

  //     // Update table
  //     this.tableDataSource = new MatTableDataSource<any>(filteredData);
  //     this.tableDataSource._updateChangeSubscription();

  //     if (this.matPaginator) {
  //       this.matPaginator.firstPage();
  //     }
  //   }

  //   onFilterSelect(allData: any[]) {
  //     console.log('=== FILTERING STARTED ===');

  //     // First normalize all status values in the data
  //     const normalizedData = this.normalizeStatusValues(allData);

  //     if (this.isFilterPresent) {
  //       const selectedFilters = this.selectedFilters?.filters || {};
  //       console.log('Active filters:', JSON.parse(JSON.stringify(selectedFilters)));

  //       const filteredData = normalizedData?.filter((element) => {
  //         //  console.group('\nFiltering element:', element.id || element.name);
  //         let shouldKeep = true;

  //         // Check all filters
  //         for (const key in selectedFilters) {
  //           const filter = selectedFilters[key];
  //           console.log(`Applying ${filter.type} filter for ${filter.datakey}`, filter);

  //           // Skip All filter as it's handled separately
  //           if (key === constants.ALL) continue;

  // if (filter.datakey === 'status') {
  //   const selectedStatusLabels = filter.tags?.[filter.datakey] || [];
  //   console.log('Selected status labels:', selectedStatusLabels);

  //   if (selectedStatusLabels.length > 0) {
  //     let statusMatch = false;

  //     // Check each selected status label
  //     statusMatch = selectedStatusLabels.some(label => {
  //       // Check for Archived first (highest priority)
  //       if (label === 'Archived') return element.is_archived;

  //       // If not archived, check Active/Inactive
  //       if (!element.is_archived) {
  //         if (label === 'Active') return element.is_active;
  //         if (label === 'Inactive') return !element.is_active;
  //       }

  //       // Check for other statuses (if any)
  //       if (element.status) {
  //         return element.status.toLowerCase() === label.toLowerCase();
  //       }
  //       return false;
  //     });

  //     if (!statusMatch) {
  //       console.log('✗ Status filter rejected for element:', element);
  //       shouldKeep = false;
  //       break;
  //     }
  //   }
  // }
  // else if (filter.datakey === 'service') {
  //   const selectedServices = filter.tags?.[filter.datakey] || [];
  //   if (selectedServices.length > 0) {
  //     const elementService = element.service?.toLowerCase();
  //     const serviceMatch = selectedServices.some(service => 
  //       elementService === service.toLowerCase()
  //     );

  //     if (!serviceMatch) {
  //       console.log('✗ Service filter rejected');
  //       shouldKeep = false;
  //       break;
  //     }
  //   }
  // }
  // else if (filter.datakey === 'unit_rate') {
  //   const elementUnitRate = parseFloat(element.unit_rate) || 0;
  //   const filterUnitRate = parseFloat(filter.isValue) || 0;

  //   if (elementUnitRate !== filterUnitRate) {
  //     console.log('✗ Unit Rate match failed');
  //     shouldKeep = false;
  //     break;
  //   }
  // }
  //  // Handle Amount filter - simple exact match
  //         if (filter.datakey === 'amount') {
  //           const elementAmount = parseFloat(element.amount) || 0;
  //           const filterAmount = parseFloat(filter.isValue) || 0;

  //           if (elementAmount !== filterAmount) {
  //             console.log('✗ Amount match failed');
  //             shouldKeep = false;
  //             break;
  //           }
  //         }
  //         if (filter.datakey === 'billed_amount') {
  //           const elementAmount = parseFloat(element.billed_amount) || 0;
  //           const filterAmount = parseFloat(filter.isValue) || 0;

  //           if (elementAmount !== filterAmount) {
  //             console.log('✗ Amount match failed');
  //             shouldKeep = false;
  //             break;
  //           }
  //         }
  // // Handle Unit Rate filter - simple exact match
  // if (filter.datakey === 'unit_rate') {
  //   const elementUnitRate = parseFloat(element.unit_rate) || 0;
  //   const filterUnitRate = parseFloat(filter.isValue) || 0;

  //   if (elementUnitRate !== filterUnitRate) {
  //     console.log('✗ Unit Rate match failed');
  //     shouldKeep = false;
  //     break;
  //   }
  // }
  //           // Handle Role filter
  //           else if (filter.datakey === 'roleName') {
  //             const selectedRoles = filter.tags?.[filter.datakey] || [];
  //             if (selectedRoles.length > 0) {
  //               const roleMatch = selectedRoles.some(role =>
  //                 element.roleName?.toLowerCase() === role.toLowerCase()
  //               );

  //               if (!roleMatch) {
  //                 console.log('✗ Role filter rejected');
  //                 shouldKeep = false;
  //                 break;
  //               }
  //             }
  //           }
  //           // Handle Created Date filter
  //           else if (filter.type === constants.DATE && filter.datakey === 'created_datetime') {
  //             const elementDate = moment(element.created_datetime);

  //             if (filter.option === 'is' && filter.start) {
  //               const filterDate = moment(filter.start);
  //               if (!elementDate.isSame(filterDate, 'day')) {
  //                 console.log('✗ Exact date match failed');
  //                 shouldKeep = false;
  //                 break;
  //               }
  //             }
  //             else if (filter.option === 'between' && filter.start && filter.end) {
  //               const startDate = moment(filter.start);
  //               const endDate = moment(filter.end);

  //               if (!elementDate.isBetween(startDate, endDate, 'day', '[]')) {
  //                 console.log('✗ Date range match failed');
  //                 shouldKeep = false;
  //                 break;
  //               }
  //             }
  //           }
  //           // Handle Last Login filter
  //           else if (filter.type === constants.DATE && filter.datakey === 'last_login') {
  //             if (!element.last_login) {
  //               console.log('✗ No last login date');
  //               shouldKeep = false;
  //               break;
  //             }

  //             const elementDate = moment(element.last_login);

  //             if (filter.option === 'is' && filter.start) {
  //               const filterDate = moment(filter.start);
  //               if (!elementDate.isSame(filterDate, 'day')) {
  //                 console.log('✗ Exact date match failed');
  //                 shouldKeep = false;
  //                 break;
  //               }
  //             }
  //             else if (filter.option === 'between' && filter.start && filter.end) {
  //               const startDate = moment(filter.start);
  //               const endDate = moment(filter.end);

  //               if (!elementDate.isBetween(startDate, endDate, 'day', '[]')) {
  //                 console.log('✗ Date range match failed');
  //                 shouldKeep = false;
  //                 break;
  //               }
  //             }
  //           }
  //           // Handle Category filter
  //           else if (filter.datakey === 'categoryName') {
  //             const selectedCategories = filter.tags?.[filter.datakey] || [];
  //             if (selectedCategories.length > 0) {
  //               const categoryMatch = selectedCategories.some(category =>
  //                 element.categoryName?.toLowerCase() === category.toLowerCase()
  //               );

  //               if (!categoryMatch) {
  //                 console.log('✗ Category filter rejected');
  //                 shouldKeep = false;
  //                 break;
  //               }
  //             }
  //           }
  //           // Handle Phone filter (number type)
  //           else if (filter.type === constants.NUMBER && filter.datakey === 'phone') {
  //             const searchPhone = filter.value?.toString().trim() || '';
  //             const elementPhone = element.phone ? element.phone.toString().trim() : '';

  //             if (filter.option === 'is' && searchPhone && elementPhone !== searchPhone) {
  //               console.log('✗ Exact phone match failed');
  //               shouldKeep = false;
  //               break;
  //             }
  //             else if (filter.option === 'contains' && searchPhone && !elementPhone.includes(searchPhone)) {
  //               console.log('✗ Contains phone match failed');
  //               shouldKeep = false;
  //               break;
  //             }
  //           }
  //           // Handle Email filter (text type)
  //           else if (filter.type === constants.TEXT && filter.datakey === 'email') {
  //             const searchEmail = filter.isValue ?
  //               filter.isValue.toString().trim().toLowerCase() :
  //               filter.containsValue?.toString().trim().toLowerCase() || '';

  //             const elementEmail = element.email ?
  //               element.email.toString().trim().toLowerCase() :
  //               '';

  //             if (filter.option === 'is' && searchEmail && elementEmail !== searchEmail) {
  //               console.log('✗ Exact email match failed');
  //               shouldKeep = false;
  //               break;
  //             }
  //             else if (filter.option === 'contains' && searchEmail && !elementEmail.includes(searchEmail)) {
  //               console.log('✗ Contains email match failed');
  //               shouldKeep = false;
  //               break;
  //             }
  //           }
  //           // Handle Name filter (text type)
  //           else if (filter.type === constants.TEXT && filter.datakey === 'name') {
  //             const searchText = filter.isValue ?
  //               filter.isValue.toString().trim().toLowerCase() :
  //               filter.containsValue?.toString().trim().toLowerCase() || '';

  //             const elementValue = element.name ?
  //               element.name.toString().trim().toLowerCase() :
  //               '';

  //             if (filter.option === 'is' && searchText && elementValue !== searchText) {
  //               console.log('✗ Exact name match failed');
  //               shouldKeep = false;
  //               break;
  //             }
  //             else if (filter.option === 'contains' && searchText && !elementValue.includes(searchText)) {
  //               console.log('✗ Contains name match failed');
  //               shouldKeep = false;
  //               break;
  //             }
  //           }          else if (filter.type === constants.TEXT && filter.datakey === 'name') {
  //             const searchText = filter.isValue ?
  //               filter.isValue.toString().trim().toLowerCase() :
  //               filter.containsValue?.toString().trim().toLowerCase() || '';

  //             const elementValue = element.name ?
  //               element.name.toString().trim().toLowerCase() :
  //               '';

  //             if (filter.option === 'is' && searchText && elementValue !== searchText) {
  //               console.log('✗ Exact name match failed');
  //               shouldKeep = false;
  //               break;
  //             }
  //             else if (filter.option === 'contains' && searchText && !elementValue.includes(searchText)) {
  //               console.log('✗ Contains name match failed');
  //               shouldKeep = false;
  //               break;
  //             }
  //           }
  //           // Add Industry Vertical filter (text type)
  //           else if (filter.type === constants.TEXT && filter.datakey === 'industry_vertical') {
  //             const searchText = filter.isValue ?
  //               filter.isValue.toString().trim().toLowerCase() :
  //               filter.containsValue?.toString().trim().toLowerCase() || '';

  //             const elementValue = element.industry_vertical ?
  //               element.industry_vertical.toString().trim().toLowerCase() :
  //               '';

  //             if (filter.option === 'is' && searchText && elementValue !== searchText) {
  //               console.log('✗ Exact industry vertical match failed');
  //               shouldKeep = false;
  //               break;
  //             }
  //             else if (filter.option === 'contains' && searchText && !elementValue.includes(searchText)) {
  //               console.log('✗ Contains industry vertical match failed');
  //               shouldKeep = false;
  //               break;
  //             }
  //           }

  //           // Add this to your existing onFilterSelect method, inside the filtering loop
  //           else if (filter.datakey === 'custom_attrs_label') {
  //             const searchText = filter.isValue ?
  //               filter.isValue.toString().trim().toLowerCase() :
  //               filter.containsValue?.toString().trim().toLowerCase() || '';

  //             if (!element.custom_attrs || !Array.isArray(element.custom_attrs)) {
  //               console.log('✗ No custom attributes to filter');
  //               shouldKeep = false;
  //               break;
  //             }

  //             // Check if any custom attribute label matches the search text
  //             const hasMatchingLabel = element.custom_attrs.some(attr => {
  //               const labelMatch = attr.labelName?.toLowerCase().includes(searchText);

  //               if (filter.option === 'is') {
  //                 return attr.labelName?.toLowerCase() === searchText;
  //               } else if (filter.option === 'contains') {
  //                 return labelMatch;
  //               }
  //               return false;
  //             });

  //             if (!hasMatchingLabel) {
  //               console.log('✗ Custom attribute label filter rejected');
  //               shouldKeep = false;
  //               break;
  //             }
  //           }
  //           else if (filter.type === constants.TEXT && filter.datakey === 'full_name') {
  //             const searchText = filter.isValue ?
  //               filter.isValue.toString().trim().toLowerCase() :
  //               filter.containsValue?.toString().trim().toLowerCase() || '';

  //             const elementValue = element.full_name ?
  //               element.full_name.toString().trim().toLowerCase() :
  //               '';

  //             if (filter.option === 'is' && searchText && elementValue !== searchText) {
  //               console.log('✗ Exact full_name match failed');
  //               shouldKeep = false;
  //               break;
  //             }
  //             else if (filter.option === 'contains' && searchText && !elementValue.includes(searchText)) {
  //               console.log('✗ Contains full_name match failed');
  //               shouldKeep = false;
  //               break;
  //             }
  //           }
  //           else if (filter.type === constants.TEXT && filter.datakey === 'username') {
  //             const searchText = filter.isValue ?
  //               filter.isValue.toString().trim().toLowerCase() :
  //               filter.containsValue?.toString().trim().toLowerCase() || '';

  //             const elementValue = element.username ?
  //               element.username.toString().trim().toLowerCase() :
  //               '';

  //             if (filter.option === 'is' && searchText && elementValue !== searchText) {
  //               console.log('✗ Exact username match failed');
  //               shouldKeep = false;
  //               break;
  //             }
  //             else if (filter.option === 'contains' && searchText && !elementValue.includes(searchText)) {
  //               console.log('✗ Contains username match failed');
  //               shouldKeep = false;
  //               break;
  //             }
  //           }
  //           else if (filter.type === constants.TEXT && filter.datakey === 'custom_attrs') {
  //             const searchText = filter.isValue ?
  //               filter.isValue.toString().trim().toLowerCase() :
  //               filter.containsValue?.toString().trim().toLowerCase() || '';

  //             const elementValue = element.custom_attrs && Array.isArray(element.custom_attrs)
  //               ? JSON.stringify(element.custom_attrs).toLowerCase()
  //               : '';

  //             if (filter.option === 'is' && searchText && elementValue !== searchText) {
  //               console.log('✗ Exact custom_attrs match failed');
  //               shouldKeep = false;
  //               break;
  //             }
  //             else if (filter.option === 'contains' && searchText && !elementValue.includes(searchText)) {
  //               console.log('✗ Contains custom_attrs match failed');
  //               shouldKeep = false;
  //               break;
  //             }
  //           }
  //           // Handle list filters (including 'type', 'status', etc.)
  //           if (filter.type === constants.LIST) {
  //             const selectedLabels = filter.tags?.[filter.datakey] || [];
  //             if (selectedLabels.length > 0) {
  //               let match = selectedLabels.some(label =>
  //                 (element[filter.datakey] || '').toString().trim().toLowerCase() === label.toString().trim().toLowerCase()
  //               );
  //               if (!match) {
  //                 shouldKeep = false;
  //                 break;
  //               }
  //             }
  //           }
  //           // Handle text filters (Title, Product, etc.)
  //           if (filter.type === constants.TEXT) {
  //             const searchText = filter.isValue
  //               ? filter.isValue.toString().trim().toLowerCase()
  //               : filter.containsValue?.toString().trim().toLowerCase() || '';
  //             const elementValue = (element[filter.datakey] || '').toString().trim().toLowerCase();
  //             if (filter.option === constants.IS && searchText && elementValue !== searchText) {
  //               shouldKeep = false;
  //               break;
  //             }
  //             if (filter.option === constants.CONTAINS && searchText && !elementValue.includes(searchText)) {
  //               shouldKeep = false;
  //               break;
  //             }
  //           }
  //         }

  //         console.groupEnd();
  //         return shouldKeep;
  //       });

  //       console.log('=== FILTERING COMPLETE ===');
  //       console.log('Results:', filteredData);
  //       return filteredData || normalizedData;
  //     }
  //     return normalizedData;
  //   }

  onPassPercentageAttributeClick(attribute: any, row: any) {
    if (attribute._isPassPercentage && attribute._originalDetails) {
      this.showPassPercentageDetails(attribute._originalDetails, row);
    }
  }
  getSafeArray(value: any): any[] {
    if (Array.isArray(value)) {
      return value;
    }
    if (typeof value === 'string') {
      try {
        const parsed = JSON.parse(value);
        if (Array.isArray(parsed)) {
          return parsed;
        }
        if (parsed && typeof parsed === 'object') {
          return [parsed];
        }
      } catch {
        return [];
      }
    }
    if (value && typeof value === 'object') {
      return [value];
    }
    return [];
  }

  getTagDisplayText(tag: any): string {
    if (tag === null || tag === undefined) {
      return '';
    }

    // If the tag is just an ID or a numeric string, resolve it from the cached master tags.
    if (typeof tag === 'number' || (typeof tag === 'string' && /^[0-9]+$/.test(tag))) {
      const tagId = Number(tag);
      const masterTag = this.getTagFromCache(tagId);
      if (masterTag) {
        return `${masterTag.key}:${masterTag.value}`;
      }
      return String(tag);
    }

    if (typeof tag === 'string') {
      return String(tag);
    }

    if (typeof tag === 'object') {
      if ('key' in tag && 'value' in tag) {
        return `${tag.key}:${tag.value}`;
      }
      if ('id' in tag && !('key' in tag) && !('value' in tag)) {
        const masterTag = this.getTagFromCache(Number(tag.id));
        if (masterTag) {
          return `${masterTag.key}:${masterTag.value}`;
        }
      }
      if ('name' in tag) {
        return String(tag.name);
      }
      if ('key' in tag && !('value' in tag)) {
        return String(tag.key);
      }
      if ('label' in tag) {
        return String(tag.label);
      }
      if ('id' in tag && 'name' in tag) {
        return String(tag.name);
      }
    }

    return String(tag);
  }

  getTagKeyValue(tag: any): { key: string; value: string } {
    if (!tag) return { key: '', value: '' };

    if (typeof tag === 'string') {
      const parts = tag.split(':');
      if (parts.length >= 2) {
        return {
          key: parts[0].trim().toLowerCase(),
          value: parts.slice(1).join(':').trim().toLowerCase()
        };
      }
      return { key: '', value: tag.trim().toLowerCase() };
    }

    if (typeof tag === 'object') {
      const key = (tag.key || tag.type || '').toString().trim().toLowerCase();
      let val = '';

      if (tag.value !== undefined && tag.value !== null && String(tag.value).trim() !== '') {
        val = String(tag.value).trim().toLowerCase();
      } else if (tag.label !== undefined && tag.label !== null && String(tag.label).trim() !== '') {
        val = String(tag.label).trim().toLowerCase();
      } else if (tag.name !== undefined && tag.name !== null && String(tag.name).trim() !== '') {
        val = String(tag.name).trim().toLowerCase();
      } else if (tag.key && tag[tag.key] !== undefined && tag[tag.key] !== null && String(tag[tag.key]).trim() !== '') {
        val = String(tag[tag.key]).trim().toLowerCase();
      } else if (tag.type && tag[tag.type] !== undefined && tag[tag.type] !== null && String(tag[tag.type]).trim() !== '') {
        val = String(tag[tag.type]).trim().toLowerCase();
      } else {
        for (const k of Object.keys(tag)) {
          if (!['id', 'key', 'type', 'created_datetime', 'modified_datetime', 'tag_id', 'tag_type'].includes(k)) {
            if (tag[k] !== undefined && tag[k] !== null && String(tag[k]).trim() !== '') {
              val = String(tag[k]).trim().toLowerCase();
              break;
            }
          }
        }
      }

      return { key, value: val };
    }

    return { key: '', value: String(tag).trim().toLowerCase() };
  }

  @Output() passPercentageClick = new EventEmitter<any>();
  @Output() showPassPercentageModal = new EventEmitter<{ data: any, type: string }>();

  private normalizeStatus(status: any): boolean {
    if (typeof status === 'boolean') return status;
    if (typeof status === 'string') {
      return status.toLowerCase() === 'true' || status === '1';
    }
    if (typeof status === 'number') {
      return status === 1;
    }
    return false;
  }

  private normalizeStatusValues(data: any[]): any[] {
    return data.map(item => {
      if (item.is_active !== undefined || item.status !== undefined) {
        const statusValue = item.is_active !== undefined ?
          item.is_active :
          item.status;
        item.is_active = this.normalizeStatus(statusValue);
      }
      return item;
    });
  }

  getPassPercentageColor(value: string): string {
    // ✅ Add null/undefined check
    if (!value) {
      return '#E0E0E0'; // Default color for undefined/null values
    }

    try {
      // ✅ Safe parsing with error handling
      const percentage = parseInt(value.toString().replace('%', '')) || 0;

      if (percentage === 100) return '#E0E0E0';
      if (percentage >= 50) return '#E0E0E0';
      return '#E0E0E0';
    } catch (error) {
      console.warn('Error parsing pass percentage:', error, 'Value:', value);
      return '#E0E0E0'; // Default color on error
    }
  }

  onPassPercentageClick(passItem: any, row: any) {

    if (passItem && passItem._originalDetails) {
      this.showPassPercentageDetails(passItem._originalDetails, row);
    } else {
      if (row.pass_analysis) {
        this.showPassPercentageDetails(row.pass_analysis, row);
      }
    }
  }

  onPassPercentageShowAll(passAnalysis: any[], row: any) {
    if (passAnalysis && passAnalysis.length > 0) {
      const analysisData = passAnalysis[0]._originalDetails || passAnalysis[0];
      this.showPassPercentageDetails(analysisData, row);
    }
  }

  showPassPercentageDetails(passAnalysis: any, candidate: any) {

    if (!passAnalysis) {
      return;
    }

    const modalData = {
      candidate: candidate,
      passAnalysis: passAnalysis,
      details: passAnalysis.pass_details || []
    };

    this.showPassPercentageModal.emit({
      data: modalData,
      type: 'passPercentage'
    });
  }



  dateRangeChange(allData: any[]) {
    const dateFilter = this.selectedFilters.filters[constants.DATE];
    if (!dateFilter && !this.range.value.start && !this.range.value.end) {
      return allData;
    }

    const filteredData = allData.filter((item) => {
      //const itemDateStr = item.addedOn || item.created_datetime;
      const dateField = dateFilter?.datakey || 'created_datetime' || 'addedOn';
      const itemDateStr = item[dateField];

      // Skip items without a date
      if (!itemDateStr) {
        return false;
      }


      // Try parsing in both formats
      let itemDate;
      itemDate = moment(itemDateStr);

      // If not valid ISO, try your specific format based on the field
      if (!itemDate.isValid()) {
        if (itemDateStr === item.last_login) {
          // For last_login, expect ISO format - if invalid, skip
          return false;
        } else {
          // For other dates, try your standard format (DD-MMM-YYYY)
          itemDate = moment(itemDateStr, 'DD-MMM-YYYY');
        }
      }
      if (!itemDate.isValid()) {
        return false;
      }
      if (itemDateStr.includes('-')) {
        // Try YYYY-MM-DD format first
        itemDate = moment(itemDateStr, 'YYYY-MM-DD');
        if (!itemDate.isValid()) {
          // Try DD-MMM-YYYY format if first fails
          itemDate = moment(itemDateStr, 'DD-MMM-YYYY');
        }
      } else {
        // Try DD-MMM-YYYY format first
        itemDate = moment(itemDateStr, 'DD-MMM-YYYY');
        if (!itemDate.isValid()) {
          // Try YYYY-MM-DD format if first fails
          itemDate = moment(itemDateStr, 'YYYY-MM-DD');
        }
      }

      if (!itemDate.isValid()) {
        return false;
      }

      // Handle "is" (exact date) filter
      if (dateFilter?.option === 'is' && dateFilter.start) {
        const filterDate = moment(dateFilter.start);
        return itemDate.isSame(filterDate, 'day');
      }

      // Handle date range from the range picker
      const rangeStart = this.range.value.start ? moment(this.range.value.start) : null;
      const rangeEnd = this.range.value.end ? moment(this.range.value.end) : null;

      // Handle "between" filter from filter panel
      const filterStart = dateFilter?.start ? moment(dateFilter.start) : null;
      const filterEnd = dateFilter?.end ? moment(dateFilter.end) : null;

      // Determine which dates to use (priority to filter panel if both exist)
      const startDate = filterStart || rangeStart;
      const endDate = filterEnd || rangeEnd;

      // Check date range
      let inRange = true;
      if (startDate) {
        inRange = inRange && itemDate.isSameOrAfter(startDate, 'day');
      }
      if (endDate) {
        inRange = inRange && itemDate.isSameOrBefore(endDate, 'day');
      }

      return inRange;
    });

    return filteredData;
  }
  // onSelect(filters: any) {
  //   switch (filters.type) {
  //     case constants.ALL: {
  //       this.selectedFilters.filters[constants.ALL] = { ...filters };
  //       this.applyFilter(filters.value, filters.type);
  //       break;
  //     }
  //     case constants.DATE: {
  //       this.selectedFilters.filters[constants.DATE] = { ...filters };
  //       if (filters.option === constants.IS) {
  //         this.range = new FormGroup({
  //           start: new FormControl(filters.start),
  //           end: new FormControl(filters.end),
  //         });
  //         this.filters();
  //       } else {
  //         this.range = new FormGroup({
  //           start: new FormControl(filters.start),
  //           end: new FormControl(filters.end),
  //         });
  //         this.filters();
  //       }
  //       break;
  //     }
  //     case constants.TEXT: {
  //       this.selectedFilters.filters[filters.datakey] = { ...filters };
  //       this.filters();
  //       break;
  //     }
  //     case constants.NUMBER: {
  //       this.selectedFilters.filters[filters.datakey] = { ...filters };
  //       this.filters();
  //       break;
  //     }
  //     case constants.LIST: {
  //       if (filters.tags?.[filters.datakey]?.length) {
  //         this.selectedFilters.filters[filters.datakey] = { ...filters };
  //         this.filters();
  //       }
  //       break;
  //     }
  //     case constants.STATUS: {
  //       if (filters.tags?.[filters.datakey]?.length) {
  //         this.selectedFilters.filters[filters.datakey] = { ...filters };
  //         this.filters();
  //       }
  //       break;
  //     }
  //   }
  // }

  // Filter apply hone par console log add karo
  onSelect(filters: any) {
    console.log('🔍 Filter applied:', filters);

    const type = filters.type;
    const key = filters.datakey || type;

    this.selectedFilters.filters[key] = { ...filters };
    this.filteredData.filters[key] = { ...filters };

    console.log('📊 Current selectedFilters:', this.selectedFilters);
    console.log('📊 Current filteredData:', this.filteredData);

    // Only apply if meaningful selection exists
    const hasValue =
      (filters.value && filters.value.length > 0) ||
      (filters.tags && Object.keys(filters.tags).length > 0) ||
      filters.isValue ||
      filters.containsValue ||
      (filters.start && filters.end) ||
      (filters.type === 'date' && filters.option === 'is' && filters.start) ||
      (filters.type === 'amount' && (
        (filters.operator === 'between' && filters.start !== null && filters.start !== undefined && filters.start !== '' && filters.end !== null && filters.end !== undefined && filters.end !== '') ||
        (filters.operator !== 'between' && filters.value !== null && filters.value !== undefined && filters.value !== '')
      )) ||
      (filters.type === 'pass_percentage' && (
        (filters.operator === 'between' && filters.start !== null && filters.start !== undefined && filters.start !== '' && filters.end !== null && filters.end !== undefined && filters.end !== '') ||
        (filters.operator !== 'between' && filters.value !== null && filters.value !== undefined && filters.value !== '')
      )) ||
      (filters.type === 'tat_days' && (
        (filters.operator === 'between' && filters.start !== null && filters.start !== undefined && filters.start !== '' && filters.end !== null && filters.end !== undefined && filters.end !== '') ||
        (filters.operator !== 'between' && filters.value !== null && filters.value !== undefined && filters.value !== '')
      )) ||
      (filters.type === 'impression_count' && (
        (filters.operator === 'between' && filters.start !== null && filters.start !== undefined && filters.start !== '' && filters.end !== null && filters.end !== undefined && filters.end !== '') ||
        (filters.operator !== 'between' && filters.value !== null && filters.value !== undefined && filters.value !== '')
      ));

    if (this.moduleType === 'questions' || this.pageType === 'question banks') {
      this.tableActionEmitter.emit({
        type: 'serverFilter',
        filters: this.selectedFilters.filters
      });
      return;
    }

    if (this.pageType === 'assessments' || this.serverSidePagination) {
      if (filters.type === 'clear') {
        (this.selectedFilters as any).filters = {};
        (this.filteredData as any).filters = {};
      } else if (!hasValue) {
        delete (this.selectedFilters.filters as Record<string, any>)[key];
        delete (this.filteredData.filters as Record<string, any>)[key];
      }
      this.tableActionEmitter.emit({
        type: 'serverFilter',
        filters: this.selectedFilters.filters
      });
      return;
    }

    if (hasValue) {
      console.log('✅ Applying filter...');
      this.filters();
    } else {
      console.log('❌ No filter value, clearing...');
      delete this.selectedFilters.filters[key];
      delete this.filteredData.filters[key];
      this.filters();
    }
  }
  getTatAnalysisColor(value: string): string {
    // ✅ Add null/undefined check
    if (!value) {
      return '#E0E0E0'; // Default color for undefined/null values
    }

    try {
      // ✅ Safe parsing with error handling
      const days = parseInt(value.toString().replace(' days', '')) || 0;

      if (days === 0) return '#E0E0E0';
      if (days <= 7) return '#E0E0E0';
      if (days <= 14) return '#E0E0E0';
      return '#E0E0E0';
    } catch (error) {
      console.warn('Error parsing TAT days:', error, 'Value:', value);
      return '#E0E0E0'; // Default color on error
    }
  }

  onTatAnalysisClick(tatItem: any, row: any) {
    if (tatItem && tatItem._originalDetails) {
      this.showTatAnalysisDetails(tatItem._originalDetails, row);
    } else {
      if (row.tat_analysis) {
        this.showTatAnalysisDetails(row.tat_analysis, row);
      }
    }
  }

  onTatAnalysisShowAll(tatAnalysis: any[], row: any) {
    if (tatAnalysis && tatAnalysis.length > 0) {
      const analysisData = tatAnalysis[0]._originalDetails || tatAnalysis[0];
      this.showTatAnalysisDetails(analysisData, row);
    }
  }

  showTatAnalysisDetails(tatAnalysis: any, candidate: any) {

    if (!tatAnalysis) {
      return;
    }

    const modalData = {
      candidate: candidate,
      tatAnalysis: tatAnalysis,
      details: tatAnalysis.tat_details || []
    };

    this.showTatAnalysisModal.emit({
      data: modalData,
      type: 'tatAnalysis'
    });
  }
  onShowTatAnalysisModal(event: any) {
    if (event.type === 'tatAnalysis') {
      this.showTatDetails(event.data.tatAnalysis, event.data.candidate);
    }
  }

  showTatDetails(tatAnalysis: any, candidate: any) {

    this.selectedCandidate = candidate;
    this.selectedTatAnalysis = tatAnalysis;

    $('#TatAnalysisDetailsPopup').modal('show');
  }

  @Output() tatAnalysisClick = new EventEmitter<any>();
  @Output() showTatAnalysisModal = new EventEmitter<{ data: any, type: string }>();

  getFilter(itemKey, itemValue) {
    if (itemValue.type === constants.STATUS) {
      const statuses = itemValue?.value || [];
      return `* ${itemValue.name} * includes * [${statuses.join(', ')}] *`;
    }
    if (itemValue.type === constants.LIST) {
      return `* ${itemValue.name} * includes * [${itemValue.tags[itemKey]}] *`;
    }
    if (itemValue.type === constants.TEXT || itemValue.type === constants.NUMBER) {
      if (itemValue.option === constants.IS) {
        return `* ${itemValue.name} * is * ${itemValue.isValue} *`;
      }
      if (itemValue.option === constants.CONTAINS) {
        return `* ${itemValue.name} * contains * ${itemValue.containsValue} *`;
      }
      if (itemValue.option === constants.BETWEEN) {
        return `* ${itemValue.name} * is between * ${itemValue.start} * and * ${itemValue.end} *`;
      }
    }
    if (itemValue.type === constants.DATE) {
      if (itemValue.option === constants.IS) {
        return `* ${itemValue.name} * is * ${moment(itemValue.start).format('DD-MMM-YYYY')} *`;
      }
      if (itemValue.option === constants.BETWEEN) {
        return `* ${itemValue.name} * is between * ${moment(itemValue.start).format('DD-MMM-YYYY')} * and * ${moment(itemValue.end).format('DD-MMM-YYYY')} *`;
      }
    }
    if (itemValue.type === constants.ALL) {
      return `search: * ${itemValue.value} *`;
    }
  }

  clearFilterItem(item) {
    if (this.pageType === 'assessments' || this.serverSidePagination) {
      delete (this.selectedFilters.filters as Record<string, any>)[item.key];
      delete (this.filteredData.filters as Record<string, any>)[item.key];
      if (item.key === constants.DATE || item.key === 'addedOn') {
        this.range = new FormGroup({
          start: new FormControl<Date | null>(null),
          end: new FormControl<Date | null>(null),
        });
      }
      this.tableActionEmitter.emit({
        type: 'serverFilter',
        filters: this.selectedFilters.filters
      });
      return;
    }

    if (item.key === constants.ALL) {
      delete this.selectedFilters.filters[item.key];
      this.applyFilter('', constants.ALL);
    } else if (item.key === constants.DATE) {
      delete this.selectedFilters.filters[item.key];
      this.range = new FormGroup({
        start: new FormControl<Date | null>(null),
        end: new FormControl<Date | null>(null),
      });
      this.filters();
    } else {
      delete this.selectedFilters.filters[item.key];
      this.filters();
    }

    this.tableDataSource.data = [...this.tableDataSource.data];

    if (this.matPaginator) {
      this.matPaginator.length = this.tableDataSource.data.length;
      this.matPaginator.firstPage();
      this.tableDataSource.paginator = this.matPaginator;
      this.tableDataSource._updateChangeSubscription();
    }
  }


  getStrippedLength(text: string): number {
    if (!text) return 0;
    const strippedText = text.toString().replace(/<[^>]*>/g, "");
    return strippedText.length;
  }

  getFormattedText(text: string): string {
    if (!text) return "";
    return text.toString().replace(/<br\s*\/?>/gi, "\n").replace(/<[^>]*>/g, "").trim();
  }

  closeModal() {
    if (this.dialogRef) {
      this.dialogRef.close();
      this.dialogRef = null;
    }
  }

  onMenuClosed() {
    // This method is called when the menu is closed
  }

  // Helper method to check if tags is an array of objects with key-value pairs
  isTagsArray(tags: any): boolean {
    if (!tags || !Array.isArray(tags)) return false;
    return tags.length > 0 && typeof tags[0] === 'object' && 'key' in tags[0] && 'value' in tags[0];
  }

  /**
   * Show dropdown with additional labels when clicking the +N grey dot
   */
  showTableLabelDropdown(event: MouseEvent, labels: any[]): void {
    event.stopPropagation();
    event.preventDefault();
    
    const target = event.currentTarget as HTMLElement; // Use currentTarget
    this.tableLabelDropdownTarget = target; // You need to add this property
    
    const rect = target.getBoundingClientRect();
    
    this.tableRemainningLabels = labels;
    this.tableDropdownPosition = {
      top: rect.bottom + window.scrollY + 5,
      left: rect.left + window.scrollX - 50
    };
    this.showTableLabelDropdownFlag = true;
    this.cdr.detectChanges();
    
    // Add listeners
    this.addTableDropdownListeners();
  }

  closeTableLabelDropdown(): void {
    this.showTableLabelDropdownFlag = false;
    this.tableRemainningLabels = [];
    this.tableLabelDropdownTarget = null;
    this.removeTableDropdownListeners();
    this.cdr.detectChanges();
  }

  toggleTableLabelDropdown(event: MouseEvent, labels: any[]): void {
    event.stopPropagation();
    event.preventDefault();
    
    if (this.showTableLabelDropdownFlag) {
      this.closeTableLabelDropdown();
    } else {
      this.showTableLabelDropdown(event, labels);
    }
  }


  private addTableDropdownListeners(): void {
    window.addEventListener('scroll', this.handleTableDropdownScroll, { passive: true });
    window.addEventListener('resize', this.handleTableDropdownResize, { passive: true });
    
    const tableWrapper = document.querySelector('.table-wrapper');
    if (tableWrapper) {
      tableWrapper.addEventListener('scroll', this.handleTableDropdownScroll, { passive: true });
    }
  }


  private removeTableDropdownListeners(): void {
    window.removeEventListener('scroll', this.handleTableDropdownScroll);
    window.removeEventListener('resize', this.handleTableDropdownResize);
    
    const tableWrapper = document.querySelector('.table-wrapper');
    if (tableWrapper) {
      tableWrapper.removeEventListener('scroll', this.handleTableDropdownScroll);
    }
  }


  handleTableDropdownScroll = (): void => {
    if (!this.showTableLabelDropdownFlag || !this.tableLabelDropdownTarget) {
      return;
    }
    
    const rect = this.tableLabelDropdownTarget.getBoundingClientRect();
    
    const isVisible = (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
    
    if (!isVisible) {
      this.closeTableLabelDropdown();
      return;
    }
    
  }
  tableLabelDropdownTarget: HTMLElement | null = null;


  handleTableDropdownResize = (): void => {
    if (!this.showTableLabelDropdownFlag || !this.tableLabelDropdownTarget) {
      return;
    }
    
    const rect = this.tableLabelDropdownTarget.getBoundingClientRect();
    
    this.tableDropdownPosition = {
      top: rect.bottom + window.scrollY + 5,
      left: rect.left + window.scrollX - 50
    };
    
    this.cdr.detectChanges();
  }

      // Check if text is actually truncated with ellipsis
  isTextTruncated(text: string): boolean {
    if (!text) return false;
    // If text is more than 80 chars, it will likely be truncated in the cell
    return this.getStrippedLength(text) > 80;
  }

  // Load all tags from tag-master service and cache them
  private loadAllTags(): void {
    if (this.tagsLoaded) {
      console.log('🏷️ Tags already loaded, skipping');
      return;
    }

    this.tagsMasterService.getAllTags().subscribe(
      (tagsData: any[]) => {
        if (Array.isArray(tagsData)) {
          // Build cache map with tag ID as key
          tagsData.forEach(tag => {
            if (tag.id) {
              this.tagsCache.set(tag.id, tag);
            }
          });
          this.tagsLoaded = true;
        }
      },
      (error: any) => {
        console.error('🏷️ Error loading tags:', error);
      }
    );
  }

  // Helper method to get tag details from cache
  private getTagFromCache(tagId: number): any {
    return this.tagsCache.get(tagId) || null;
  }
}
